/**
 * © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED
 * Tinder Obsidian v10.19.0
 * Do not edit directly
 * Generated on Fri, 08 Nov 2024 21:12:45 GMT
 */

import { ObsidianTheme } from '../types';
import {
  COLOR_BLACK,
  COLOR_BLUE_10,
  COLOR_BLUE_15,
  COLOR_BLUE_20,
  COLOR_BLUE_40,
  COLOR_BLUE_50,
  COLOR_BLUE_60,
  COLOR_BLUE_70,
  COLOR_BLUE_80,
  COLOR_BLUE_90,
  COLOR_BLUE_95,
  COLOR_DARK_ACCENT_ACTIVE,
  COLOR_DARK_ACCENT_BLUE,
  COLOR_DARK_ACCENT_BOOST,
  COLOR_DARK_ACCENT_BRAND,
  COLOR_DARK_ACCENT_CHAT,
  COLOR_DARK_ACCENT_ERROR,
  COLOR_DARK_ACCENT_FUCHSIA,
  COLOR_DARK_ACCENT_GOLD,
  COLOR_DARK_ACCENT_GREEN,
  COLOR_DARK_ACCENT_LIKE,
  COLOR_DARK_ACCENT_LINK,
  COLOR_DARK_ACCENT_NOPE,
  COLOR_DARK_ACCENT_PLATINUM,
  COLOR_DARK_ACCENT_PRIMARY,
  COLOR_DARK_ACCENT_PRIMARY_A11Y,
  COLOR_DARK_ACCENT_PURPLE,
  COLOR_DARK_ACCENT_RED,
  COLOR_DARK_ACCENT_REWIND,
  COLOR_DARK_ACCENT_SELECT,
  COLOR_DARK_ACCENT_SUCCESS,
  COLOR_DARK_ACCENT_SUPER_LIKE,
  COLOR_DARK_ACCENT_TEAL,
  COLOR_DARK_ACCENT_TRUST,
  COLOR_DARK_ACCENT_YELLOW_ORANGE,
  COLOR_DARK_ACTION_ACTIVE,
  COLOR_DARK_ACTION_INACTIVE,
  COLOR_DARK_ACTION_NAVIGATION_SECONDARY_DISABLED,
  COLOR_DARK_ACTION_TEXT_FIELD_LOUD_ACTIVE,
  COLOR_DARK_ACTION_TEXT_FIELD_LOUD_INACTIVE,
  COLOR_DARK_ACTION_TEXT_FIELD_QUIET_ACTIVE,
  COLOR_DARK_ACTION_TEXT_FIELD_QUIET_INACTIVE,
  COLOR_DARK_BACKGROUND_BADGE_BRAND_DEFAULT,
  COLOR_DARK_BACKGROUND_BADGE_NOTIFICATION_ACTIVE,
  COLOR_DARK_BACKGROUND_BADGE_NOTIFICATION_INACTIVE,
  COLOR_DARK_BACKGROUND_BADGE_ONLINE_NOW_DEFAULT,
  COLOR_DARK_BACKGROUND_BADGE_VERIFIED_DEFAULT,
  COLOR_DARK_BACKGROUND_BANNER_DEFAULT,
  COLOR_DARK_BACKGROUND_BLUE,
  COLOR_DARK_BACKGROUND_BOTTOM_SHEET_DEFAULT,
  COLOR_DARK_BACKGROUND_BRAND,
  COLOR_DARK_BACKGROUND_BUTTON_DISABLED,
  COLOR_DARK_BACKGROUND_BUTTON_ELEVATED,
  COLOR_DARK_BACKGROUND_BUTTON_NEUTRAL,
  COLOR_DARK_BACKGROUND_BUTTON_PRIMARY_OVERLAY,
  COLOR_DARK_BACKGROUND_BUTTON_PRIMARY_SMALL,
  COLOR_DARK_BACKGROUND_BUTTON_SPARKS_EXPAND_PROFILE,
  COLOR_DARK_BACKGROUND_BUTTON_SPARKS_NEUTRAL,
  COLOR_DARK_BACKGROUND_CARD_DEFAULT,
  COLOR_DARK_BACKGROUND_CARD_SPARKS,
  COLOR_DARK_BACKGROUND_CHAT_BUBBLE_RECEIVE,
  COLOR_DARK_BACKGROUND_CHAT_BUBBLE_SEND,
  COLOR_DARK_BACKGROUND_CHECKBOX_DISABLED,
  COLOR_DARK_BACKGROUND_CHECKBOX_SELECTED_ENABLED,
  COLOR_DARK_BACKGROUND_DATEPICKER_SELECTED,
  COLOR_DARK_BACKGROUND_DISABLED,
  COLOR_DARK_BACKGROUND_ELEVATED,
  COLOR_DARK_BACKGROUND_ERROR,
  COLOR_DARK_BACKGROUND_FUCHSIA,
  COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DEFAULT,
  COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DISABLED,
  COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE,
  COLOR_DARK_BACKGROUND_GAMEPAD_SECONDARY_DEFAULT,
  COLOR_DARK_BACKGROUND_GAMEPAD_SECONDARY_DISABLED,
  COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_BOOST_DEFAULT,
  COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_LIKE_DEFAULT,
  COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_NOPE_DEFAULT,
  COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_REWIND_DEFAULT,
  COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT,
  COLOR_DARK_BACKGROUND_GREEN,
  COLOR_DARK_BACKGROUND_HEADER_SPARKS,
  COLOR_DARK_BACKGROUND_ICON_BUTTON_DISABLED,
  COLOR_DARK_BACKGROUND_ICON_BUTTON_OVERLAY_DEFAULT,
  COLOR_DARK_BACKGROUND_ICON_BUTTON_OVERLAY_DISABLED,
  COLOR_DARK_BACKGROUND_ICON_BUTTON_SECONDARY,
  COLOR_DARK_BACKGROUND_INACTIVE,
  COLOR_DARK_BACKGROUND_MENU_DEFAULT,
  COLOR_DARK_BACKGROUND_MODAL_CONTAINER_DEFAULT,
  COLOR_DARK_BACKGROUND_MODAL_OVERLAY_DEFAULT,
  COLOR_DARK_BACKGROUND_MODAL_OVERLAY_RECS,
  COLOR_DARK_BACKGROUND_OVERLAY_PRIMARY,
  COLOR_DARK_BACKGROUND_OVERLAY_SECONDARY,
  COLOR_DARK_BACKGROUND_PASSIONS_EDIT,
  COLOR_DARK_BACKGROUND_PASSIONS_INACTIVE_OVERLAY,
  COLOR_DARK_BACKGROUND_PASSIONS_SHARED,
  COLOR_DARK_BACKGROUND_PASSIONS_SHARED_OVERLAY,
  COLOR_DARK_BACKGROUND_PASSIONS_SPARKS_INACTIVE,
  COLOR_DARK_BACKGROUND_PASSIONS_SPARKS_INACTIVE_OVERLAY,
  COLOR_DARK_BACKGROUND_PRIMARY,
  COLOR_DARK_BACKGROUND_PRIMARY_INVERSE,
  COLOR_DARK_BACKGROUND_PRIMARY_STATIC_DARK,
  COLOR_DARK_BACKGROUND_PRIMARY_STATIC_LIGHT,
  COLOR_DARK_BACKGROUND_PROGRESS_INACTIVE,
  COLOR_DARK_BACKGROUND_PURPLE,
  COLOR_DARK_BACKGROUND_RADIO_SELECTED_DISABLED,
  COLOR_DARK_BACKGROUND_RADIO_SELECTED_ENABLED,
  COLOR_DARK_BACKGROUND_RADIO_UNSELECTED_DISABLED,
  COLOR_DARK_BACKGROUND_READ_RECEIPTS_BADGE,
  COLOR_DARK_BACKGROUND_REC_CARD_BOTTOM_DEFAULT,
  COLOR_DARK_BACKGROUND_REC_CARD_BOTTOM_SUPER_LIKE,
  COLOR_DARK_BACKGROUND_REC_CARD_CONTENT_HIDDEN,
  COLOR_DARK_BACKGROUND_RED,
  COLOR_DARK_BACKGROUND_RIPPLE_DEFAULT,
  COLOR_DARK_BACKGROUND_SEARCH_DEFAULT,
  COLOR_DARK_BACKGROUND_SECONDARY,
  COLOR_DARK_BACKGROUND_SECONDARY_INVERSE,
  COLOR_DARK_BACKGROUND_SECONDARY_STATIC_DARK,
  COLOR_DARK_BACKGROUND_SECONDARY_STATIC_LIGHT,
  COLOR_DARK_BACKGROUND_SLIDER_ALT_FILL_DISABLED,
  COLOR_DARK_BACKGROUND_SLIDER_ALT_FILL_ENABLED,
  COLOR_DARK_BACKGROUND_SLIDER_ALT_KNOB_DISABLED,
  COLOR_DARK_BACKGROUND_SLIDER_ALT_KNOB_ENABLED,
  COLOR_DARK_BACKGROUND_SLIDER_ALT_TRACK_DISABLED,
  COLOR_DARK_BACKGROUND_SLIDER_ALT_TRACK_ENABLED,
  COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_FILL_DISABLED,
  COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_FILL_ENABLED,
  COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_KNOB_DISABLED,
  COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_KNOB_ENABLED,
  COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_TRACK_DISABLED,
  COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_TRACK_ENABLED,
  COLOR_DARK_BACKGROUND_SPARKS_BOTTOM_NAV,
  COLOR_DARK_BACKGROUND_SPARKS_PROFILE,
  COLOR_DARK_BACKGROUND_SPARKS_PROMPT,
  COLOR_DARK_BACKGROUND_SPARKS_TOP_NAV,
  COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_DISABLED,
  COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_SELECTED,
  COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_UNSELECTED,
  COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_DISABLED,
  COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_SELECTED,
  COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_UNSELECTED,
  COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_DISABLED,
  COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_SELECTED,
  COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_UNSELECTED,
  COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_DISABLED,
  COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_SELECTED,
  COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_UNSELECTED,
  COLOR_DARK_BACKGROUND_TABLE_ROW_DEFAULT,
  COLOR_DARK_BACKGROUND_TABLE_ROW_HOVER,
  COLOR_DARK_BACKGROUND_TABLE_ROW_PRESSED,
  COLOR_DARK_BACKGROUND_TAPPY_CONTAINER_DEFAULT,
  COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_ACTIVE,
  COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_INACTIVE,
  COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_SPARKS_ACTIVE,
  COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_SPARKS_INACTIVE,
  COLOR_DARK_BACKGROUND_TAPPY_SPARKS,
  COLOR_DARK_BACKGROUND_TEAL,
  COLOR_DARK_BACKGROUND_TERTIARY,
  COLOR_DARK_BACKGROUND_TERTIARY_INVERSE,
  COLOR_DARK_BACKGROUND_TEXT_FIELD_LOUD_DEFAULT,
  COLOR_DARK_BACKGROUND_TEXT_FIELD_LOUD_HIGHLIGHT,
  COLOR_DARK_BACKGROUND_TEXT_FIELD_QUIET_DEFAULT,
  COLOR_DARK_BACKGROUND_TEXT_FIELD_QUIET_HIGHLIGHT,
  COLOR_DARK_BACKGROUND_TOAST_DEFAULT,
  COLOR_DARK_BACKGROUND_TOOLTIP_DEFAULT,
  COLOR_DARK_BACKGROUND_TOOLTIP_REVENUE_DEFAULT,
  COLOR_DARK_BACKGROUND_TOOLTIP_TRUST_DEFAULT,
  COLOR_DARK_BACKGROUND_TRUST,
  COLOR_DARK_BACKGROUND_VAULT,
  COLOR_DARK_BACKGROUND_YELLOW_ORANGE,
  COLOR_DARK_BORDER_ACTIVE,
  COLOR_DARK_BORDER_BOOST,
  COLOR_DARK_BORDER_BRAND,
  COLOR_DARK_BORDER_BUTTON_FOCUSED,
  COLOR_DARK_BORDER_BUTTON_FOCUSED_OVERLAY,
  COLOR_DARK_BORDER_BUTTON_SECONDARY,
  COLOR_DARK_BORDER_BUTTON_SECONDARY_OVERLAY,
  COLOR_DARK_BORDER_BUTTON_SPARKS_EXPAND_PROFILE,
  COLOR_DARK_BORDER_CARD,
  COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_DISABLED,
  COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_ENABLED,
  COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_ERROR,
  COLOR_DARK_BORDER_CONTAINER_ELEVATED,
  COLOR_DARK_BORDER_DISABLED,
  COLOR_DARK_BORDER_ERROR,
  COLOR_DARK_BORDER_FOCUS_DEFAULT,
  COLOR_DARK_BORDER_FOCUS_INVERSE,
  COLOR_DARK_BORDER_FOCUS_OVERLAY,
  COLOR_DARK_BORDER_GAMEPAD_BOOST_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_LIKE_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_NOPE_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_PRIMARY_DISABLED,
  COLOR_DARK_BORDER_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE,
  COLOR_DARK_BORDER_GAMEPAD_REWIND_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_SECONDARY_DISABLED,
  COLOR_DARK_BORDER_GAMEPAD_SPARKS_BOOST_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_SPARKS_LIKE_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_SPARKS_NOPE_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_SPARKS_REWIND_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_ACTIVE,
  COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_DEFAULT,
  COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_DISABLED,
  COLOR_DARK_BORDER_GOLD,
  COLOR_DARK_BORDER_ICON_BUTTON_DISABLED,
  COLOR_DARK_BORDER_ICON_BUTTON_PRIMARY,
  COLOR_DARK_BORDER_ICON_BUTTON_SECONDARY,
  COLOR_DARK_BORDER_LIKE,
  COLOR_DARK_BORDER_NOPE,
  COLOR_DARK_BORDER_OVERLAY,
  COLOR_DARK_BORDER_PASSIONS_ACTIVE,
  COLOR_DARK_BORDER_PASSIONS_INACTIVE,
  COLOR_DARK_BORDER_PASSIONS_SHARED,
  COLOR_DARK_BORDER_PASSIONS_SHARED_OVERLAY,
  COLOR_DARK_BORDER_PLATINUM,
  COLOR_DARK_BORDER_PRIMARY,
  COLOR_DARK_BORDER_PRIMARY_INVERSE,
  COLOR_DARK_BORDER_RADIO_SELECTED_DISABLED,
  COLOR_DARK_BORDER_RADIO_SELECTED_ENABLED,
  COLOR_DARK_BORDER_RADIO_UNSELECTED_DISABLED,
  COLOR_DARK_BORDER_RADIO_UNSELECTED_ENABLED,
  COLOR_DARK_BORDER_REC_CARD_CONTENT_HIDDEN,
  COLOR_DARK_BORDER_REWIND,
  COLOR_DARK_BORDER_SECONDARY,
  COLOR_DARK_BORDER_SECONDARY_OVERLAY,
  COLOR_DARK_BORDER_SLIDER_ALT_KNOB_DISABLED,
  COLOR_DARK_BORDER_SLIDER_ALT_KNOB_ENABLED,
  COLOR_DARK_BORDER_SLIDER_DEFAULT_KNOB_DISABLED,
  COLOR_DARK_BORDER_SLIDER_DEFAULT_KNOB_ENABLED,
  COLOR_DARK_BORDER_SPARKS_BOOST,
  COLOR_DARK_BORDER_SPARKS_LIKE,
  COLOR_DARK_BORDER_SPARKS_NOPE,
  COLOR_DARK_BORDER_SPARKS_REWIND,
  COLOR_DARK_BORDER_SPARKS_SUPER_LIKE,
  COLOR_DARK_BORDER_SUCCESS,
  COLOR_DARK_BORDER_SUPER_LIKE,
  COLOR_DARK_BORDER_SWITCH_ALT_KNOB_DISABLED,
  COLOR_DARK_BORDER_SWITCH_ALT_KNOB_SELECTED,
  COLOR_DARK_BORDER_SWITCH_ALT_KNOB_UNSELECTED,
  COLOR_DARK_BORDER_SWITCH_ALT_TRACK_DISABLED,
  COLOR_DARK_BORDER_SWITCH_ALT_TRACK_SELECTED,
  COLOR_DARK_BORDER_SWITCH_ALT_TRACK_UNSELECTED,
  COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_DISABLED,
  COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_SELECTED,
  COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_UNSELECTED,
  COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_DISABLED,
  COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_SELECTED,
  COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_UNSELECTED,
  COLOR_DARK_BORDER_TAPPY_INDICATOR_ACTIVE,
  COLOR_DARK_BORDER_TAPPY_INDICATOR_INACTIVE,
  COLOR_DARK_BORDER_TAPPY_INDICATOR_SPARKS_ACTIVE,
  COLOR_DARK_BORDER_TAPPY_INDICATOR_SPARKS_INACTIVE,
  COLOR_DARK_BORDER_TEXT_FIELD_LOUD_DEFAULT,
  COLOR_DARK_BORDER_TEXT_FIELD_LOUD_DISABLED,
  COLOR_DARK_BORDER_TEXT_FIELD_LOUD_ERROR,
  COLOR_DARK_BORDER_TEXT_FIELD_LOUD_FOCUS,
  COLOR_DARK_BORDER_TEXT_FIELD_QUIET_DEFAULT,
  COLOR_DARK_BORDER_TEXT_FIELD_QUIET_DISABLED,
  COLOR_DARK_BORDER_TEXT_FIELD_QUIET_ERROR,
  COLOR_DARK_BORDER_TEXT_FIELD_QUIET_FOCUS,
  COLOR_DARK_BORDER_TIMER_EXPIRED,
  COLOR_DARK_BORDER_TOOLTIP_DEFAULT,
  COLOR_DARK_BORDER_TOOLTIP_REVENUE_BOOST,
  COLOR_DARK_BORDER_TOOLTIP_REVENUE_LIKE,
  COLOR_DARK_BORDER_TOOLTIP_REVENUE_NOPE,
  COLOR_DARK_BORDER_TOOLTIP_REVENUE_REWIND,
  COLOR_DARK_BORDER_TOOLTIP_REVENUE_SUPER_LIKE,
  COLOR_DARK_BORDER_VAULT,
  COLOR_DARK_CURSOR_DEFAULT,
  COLOR_DARK_CURSOR_SEARCH_INPUT,
  COLOR_DARK_CURSOR_TEXT_FIELD_LOUD_DEFAULT,
  COLOR_DARK_CURSOR_TEXT_FIELD_QUIET_DEFAULT,
  COLOR_DARK_DEVICE_HOME_INDICATOR,
  COLOR_DARK_DEVICE_STATUS_BAR,
  COLOR_DARK_DEVICE_STATUS_BAR_INVERSE,
  COLOR_DARK_DIVIDER_BANNER_DEFAULT,
  COLOR_DARK_DIVIDER_PRIMARY,
  COLOR_DARK_DIVIDER_SPARKS,
  COLOR_DARK_DIVIDER_TABLE_ROW_DEFAULT,
  COLOR_DARK_DIVIDER_TABLE_ROW_SPARKS,
  COLOR_DARK_DIVIDER_TAPPY_SPARKS,
  COLOR_DARK_FOREGROUND_BLUE,
  COLOR_DARK_FOREGROUND_BORDER_ELEVATED,
  COLOR_DARK_FOREGROUND_BORDER_PRIMARY,
  COLOR_DARK_FOREGROUND_BORDER_SECONDARY,
  COLOR_DARK_FOREGROUND_BUTTON_DISABLED,
  COLOR_DARK_FOREGROUND_BUTTON_NEUTRAL,
  COLOR_DARK_FOREGROUND_BUTTON_PRIMARY,
  COLOR_DARK_FOREGROUND_BUTTON_PRIMARY_OVERLAY,
  COLOR_DARK_FOREGROUND_BUTTON_SECONDARY,
  COLOR_DARK_FOREGROUND_BUTTON_SECONDARY_OVERLAY,
  COLOR_DARK_FOREGROUND_BUTTON_SPARKS_EXPAND_PROFILE,
  COLOR_DARK_FOREGROUND_BUTTON_TERTIARY,
  COLOR_DARK_FOREGROUND_BUTTON_TERTIARY_OVERLAY,
  COLOR_DARK_FOREGROUND_DISABLED,
  COLOR_DARK_FOREGROUND_FUCHSIA,
  COLOR_DARK_FOREGROUND_GREEN,
  COLOR_DARK_FOREGROUND_INACTIVE,
  COLOR_DARK_FOREGROUND_MODAL_BODY,
  COLOR_DARK_FOREGROUND_MODAL_HEADING,
  COLOR_DARK_FOREGROUND_MODAL_ICON,
  COLOR_DARK_FOREGROUND_PRIMARY,
  COLOR_DARK_FOREGROUND_PRIMARY_INVERSE,
  COLOR_DARK_FOREGROUND_PRIMARY_STATIC_DARK,
  COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT,
  COLOR_DARK_FOREGROUND_PRIMARY_STATIC_ON_DARK,
  COLOR_DARK_FOREGROUND_PURPLE,
  COLOR_DARK_FOREGROUND_READ_RECEIPTS_BADGE,
  COLOR_DARK_FOREGROUND_RED,
  COLOR_DARK_FOREGROUND_SECONDARY,
  COLOR_DARK_FOREGROUND_SECONDARY_INVERSE,
  COLOR_DARK_FOREGROUND_SECONDARY_STATIC_DARK,
  COLOR_DARK_FOREGROUND_SECONDARY_STATIC_LIGHT,
  COLOR_DARK_FOREGROUND_TEAL,
  COLOR_DARK_FOREGROUND_YELLOW_ORANGE,
  COLOR_DARK_ICON_BADGE_VERIFIED,
  COLOR_DARK_ICON_BANNER_DEFAULT,
  COLOR_DARK_ICON_BANNER_DISMISS,
  COLOR_DARK_ICON_BRAND,
  COLOR_DARK_ICON_CHAT_DRAWER_CONTACT_CARD_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_CONTACT_CARD_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_GIF_BACKGROUND_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_GIF_BACKGROUND_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_GIF_FOREGROUND_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_GIF_FOREGROUND_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_STICKER_ACTIVE,
  COLOR_DARK_ICON_CHAT_DRAWER_STICKER_DEFAULT,
  COLOR_DARK_ICON_CHAT_DRAWER_VIBES_DEFAULT,
  COLOR_DARK_ICON_CHAT_HEART_ACTIVE,
  COLOR_DARK_ICON_CHAT_HEART_DEFAULT,
  COLOR_DARK_ICON_CHECKBOX_SELECTED_DISABLED,
  COLOR_DARK_ICON_CHECKBOX_SELECTED_ENABLED,
  COLOR_DARK_ICON_DISABLED,
  COLOR_DARK_ICON_ERROR,
  COLOR_DARK_ICON_FORM_DEFAULT,
  COLOR_DARK_ICON_FORM_DISABLED,
  COLOR_DARK_ICON_FORM_ERROR,
  COLOR_DARK_ICON_FORM_SUCCESS,
  COLOR_DARK_ICON_GAMEPAD_PRIMARY_DISABLED,
  COLOR_DARK_ICON_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE,
  COLOR_DARK_ICON_GAMEPAD_PRIMARY_PRESSED,
  COLOR_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_ACTIVE,
  COLOR_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DISABLED,
  COLOR_DARK_ICON_GAMEPAD_SECONDARY_DISABLED,
  COLOR_DARK_ICON_GAMEPAD_SECONDARY_PRESSED,
  COLOR_DARK_ICON_GAMEPAD_SPARKS_BOOST_ACTIVE,
  COLOR_DARK_ICON_GAMEPAD_SPARKS_LIKE_ACTIVE,
  COLOR_DARK_ICON_GAMEPAD_SPARKS_NOPE_ACTIVE,
  COLOR_DARK_ICON_GAMEPAD_SPARKS_REWIND_ACTIVE,
  COLOR_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_ACTIVE,
  COLOR_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DISABLED,
  COLOR_DARK_ICON_ICON_BUTTON_DISABLED,
  COLOR_DARK_ICON_ICON_BUTTON_OVERLAY_DEFAULT,
  COLOR_DARK_ICON_ICON_BUTTON_OVERLAY_DISABLED,
  COLOR_DARK_ICON_ICON_BUTTON_PRIMARY,
  COLOR_DARK_ICON_ICON_BUTTON_SECONDARY,
  COLOR_DARK_ICON_NAVIGATION_PRIMARY_INACTIVE,
  COLOR_DARK_ICON_NAVIGATION_SECONDARY_END,
  COLOR_DARK_ICON_NAVIGATION_SECONDARY_START,
  COLOR_DARK_ICON_PRIMARY,
  COLOR_DARK_ICON_PRIMARY_INVERSE,
  COLOR_DARK_ICON_PRIMARY_OVERLAY,
  COLOR_DARK_ICON_PRIMARY_OVERLAY_INVERSE,
  COLOR_DARK_ICON_RADIO_SELECTED_DISABLED,
  COLOR_DARK_ICON_RADIO_SELECTED_ENABLED,
  COLOR_DARK_ICON_REC_CARD_CONTENT_HIDDEN,
  COLOR_DARK_ICON_SEARCH_END_ACTION,
  COLOR_DARK_ICON_SEARCH_START,
  COLOR_DARK_ICON_SECONDARY,
  COLOR_DARK_ICON_SECONDARY_INVERSE,
  COLOR_DARK_ICON_SELECTOR_SELECTED_DISABLED,
  COLOR_DARK_ICON_SELECTOR_SELECTED_ENABLED,
  COLOR_DARK_ICON_SUCCESS,
  COLOR_DARK_ICON_SWITCH_ALT_DISABLED,
  COLOR_DARK_ICON_SWITCH_ALT_SELECTED,
  COLOR_DARK_ICON_SWITCH_ALT_UNSELECTED,
  COLOR_DARK_ICON_SWITCH_DEFAULT_DISABLED,
  COLOR_DARK_ICON_SWITCH_DEFAULT_SELECTED,
  COLOR_DARK_ICON_SWITCH_DEFAULT_UNSELECTED,
  COLOR_DARK_ICON_TOOLTIP_DISMISS,
  COLOR_DARK_ICON_TRUST,
  COLOR_DARK_ICON_VAULT,
  COLOR_DARK_INTERACTIVE_BUTTON_NEUTRAL,
  COLOR_DARK_INTERACTIVE_BUTTON_PRIMARY,
  COLOR_DARK_INTERACTIVE_BUTTON_SECONDARY,
  COLOR_DARK_INTERACTIVE_BUTTON_TERTIARY,
  COLOR_DARK_INTERACTIVE_ICON_BUTTON_OVERLAY,
  COLOR_DARK_INTERACTIVE_ICON_BUTTON_PRIMARY,
  COLOR_DARK_INTERACTIVE_ICON_BUTTON_SECONDARY,
  COLOR_DARK_INTERACTIVE_ON_LIGHT,
  COLOR_DARK_INTERACTIVE_PRIMARY,
  COLOR_DARK_INTERACTIVE_SECONDARY,
  COLOR_DARK_LABEL_GAMEPAD_PRIMARY_COUNT_BOOST,
  COLOR_DARK_LABEL_GAMEPAD_PRIMARY_COUNT_SUPER_LIKE,
  COLOR_DARK_LABEL_GAMEPAD_SECONDARY_COUNT_BOOST,
  COLOR_DARK_LABEL_GAMEPAD_SECONDARY_COUNT_SUPER_LIKE,
  COLOR_DARK_LABEL_ICON_BUTTON_DISABLED,
  COLOR_DARK_LABEL_ICON_BUTTON_OVERLAY_DEFAULT,
  COLOR_DARK_LABEL_ICON_BUTTON_OVERLAY_DISABLED,
  COLOR_DARK_LABEL_ICON_BUTTON_PRIMARY,
  COLOR_DARK_LABEL_ICON_BUTTON_SECONDARY,
  COLOR_DARK_LOADER_SHIMMER_BASE_DEFAULT,
  COLOR_DARK_LOADER_SHIMMER_HIGHLIGHT_DEFAULT,
  COLOR_DARK_LOADER_SKELETON,
  COLOR_DARK_OVERLAY_DEFAULT,
  COLOR_DARK_SHADOW_CONTAINER_ELEVATED,
  COLOR_DARK_SUB_CARD_REC_CARD_SPARKS,
  COLOR_DARK_TEXT_BADGE_NOTIFICATION_DEFAULT,
  COLOR_DARK_TEXT_BADGE_NOTIFICATION_INACTIVE,
  COLOR_DARK_TEXT_BANNER_BODY,
  COLOR_DARK_TEXT_BANNER_HEADING,
  COLOR_DARK_TEXT_BOOST,
  COLOR_DARK_TEXT_BRAND_LARGE,
  COLOR_DARK_TEXT_BRAND_NORMAL,
  COLOR_DARK_TEXT_CHAT_BUBBLE_RECEIVE,
  COLOR_DARK_TEXT_CHAT_BUBBLE_SEND,
  COLOR_DARK_TEXT_DATEPICKER_ACTIVE,
  COLOR_DARK_TEXT_DATEPICKER_INACTIVE,
  COLOR_DARK_TEXT_DISABLED,
  COLOR_DARK_TEXT_ERROR,
  COLOR_DARK_TEXT_FORM_HELP_DEFAULT,
  COLOR_DARK_TEXT_FORM_HELP_DISABLED,
  COLOR_DARK_TEXT_FORM_HELP_ERROR,
  COLOR_DARK_TEXT_FORM_HELP_SUCCESS,
  COLOR_DARK_TEXT_FORM_LABEL_DEFAULT,
  COLOR_DARK_TEXT_GOLD,
  COLOR_DARK_TEXT_HIGHLIGHT_BACKGROUND,
  COLOR_DARK_TEXT_HIGHLIGHT_FOREGROUND,
  COLOR_DARK_TEXT_INACTIVE,
  COLOR_DARK_TEXT_LIKE,
  COLOR_DARK_TEXT_LINK,
  COLOR_DARK_TEXT_LINK_OVERLAY,
  COLOR_DARK_TEXT_PASSIONS_ACTIVE,
  COLOR_DARK_TEXT_PASSIONS_INACTIVE,
  COLOR_DARK_TEXT_PASSIONS_INACTIVE_OVERLAY,
  COLOR_DARK_TEXT_PASSIONS_SHARED,
  COLOR_DARK_TEXT_PASSIONS_SHARED_OVERLAY,
  COLOR_DARK_TEXT_PASSIONS_SHARED_REC,
  COLOR_DARK_TEXT_PRIMARY,
  COLOR_DARK_TEXT_PRIMARY_INVERSE,
  COLOR_DARK_TEXT_PRIMARY_OVERLAY,
  COLOR_DARK_TEXT_PRIMARY_OVERLAY_INVERSE,
  COLOR_DARK_TEXT_REC_CARD_CONTENT_HIDDEN,
  COLOR_DARK_TEXT_SEARCH_INPUT_ACTIVE,
  COLOR_DARK_TEXT_SEARCH_INPUT_INACTIVE,
  COLOR_DARK_TEXT_SEARCH_PLACEHOLDER_INACTIVE,
  COLOR_DARK_TEXT_SECONDARY,
  COLOR_DARK_TEXT_SECONDARY_INVERSE,
  COLOR_DARK_TEXT_SECONDARY_OVERLAY,
  COLOR_DARK_TEXT_SECONDARY_OVERLAY_INVERSE,
  COLOR_DARK_TEXT_SUCCESS,
  COLOR_DARK_TEXT_SUPER_BOOST,
  COLOR_DARK_TEXT_SUPER_LIKE,
  COLOR_DARK_TEXT_TEXT_FIELD_LOUD_CHARACTERCOUNT_DEFAULT,
  COLOR_DARK_TEXT_TEXT_FIELD_LOUD_INPUT_DEFAULT,
  COLOR_DARK_TEXT_TEXT_FIELD_LOUD_INPUT_DISABLED,
  COLOR_DARK_TEXT_TEXT_FIELD_LOUD_LABEL_ERROR,
  COLOR_DARK_TEXT_TEXT_FIELD_LOUD_LABEL_OPTIONAL,
  COLOR_DARK_TEXT_TEXT_FIELD_LOUD_PLACEHOLDER_DEFAULT,
  COLOR_DARK_TEXT_TEXT_FIELD_QUIET_CHARACTERCOUNT_DEFAULT,
  COLOR_DARK_TEXT_TEXT_FIELD_QUIET_INPUT_DEFAULT,
  COLOR_DARK_TEXT_TEXT_FIELD_QUIET_INPUT_DISABLED,
  COLOR_DARK_TEXT_TEXT_FIELD_QUIET_LABEL_ERROR,
  COLOR_DARK_TEXT_TEXT_FIELD_QUIET_LABEL_OPTIONAL,
  COLOR_DARK_TEXT_TEXT_FIELD_QUIET_PLACEHOLDER_DEFAULT,
  COLOR_DARK_TEXT_TOOLTIP_DEFAULT,
  COLOR_DARK_TEXT_TOOLTIP_REVENUE_DEFAULT,
  COLOR_DARK_TEXT_TOOLTIP_TRUST_DEFAULT,
  COLOR_DARK_TEXT_TRUST,
  COLOR_DARK_TEXT_VAULT_LARGE,
  COLOR_DARK_TEXT_VAULT_NORMAL,
  COLOR_FUCHSIA_10,
  COLOR_FUCHSIA_15,
  COLOR_FUCHSIA_20,
  COLOR_FUCHSIA_40,
  COLOR_FUCHSIA_50,
  COLOR_FUCHSIA_60,
  COLOR_FUCHSIA_70,
  COLOR_FUCHSIA_80,
  COLOR_FUCHSIA_90,
  COLOR_FUCHSIA_95,
  COLOR_GOLD_10,
  COLOR_GOLD_15,
  COLOR_GOLD_20,
  COLOR_GOLD_40,
  COLOR_GOLD_50,
  COLOR_GOLD_60,
  COLOR_GOLD_70,
  COLOR_GOLD_80,
  COLOR_GOLD_90,
  COLOR_GOLD_95,
  COLOR_GRAY_10,
  COLOR_GRAY_15,
  COLOR_GRAY_20,
  COLOR_GRAY_40,
  COLOR_GRAY_50,
  COLOR_GRAY_60,
  COLOR_GRAY_70,
  COLOR_GRAY_80,
  COLOR_GRAY_90,
  COLOR_GRAY_95,
  COLOR_GREEN_10,
  COLOR_GREEN_15,
  COLOR_GREEN_20,
  COLOR_GREEN_40,
  COLOR_GREEN_50,
  COLOR_GREEN_60,
  COLOR_GREEN_70,
  COLOR_GREEN_80,
  COLOR_GREEN_90,
  COLOR_GREEN_95,
  COLOR_PURPLE_10,
  COLOR_PURPLE_15,
  COLOR_PURPLE_20,
  COLOR_PURPLE_40,
  COLOR_PURPLE_50,
  COLOR_PURPLE_60,
  COLOR_PURPLE_70,
  COLOR_PURPLE_80,
  COLOR_PURPLE_90,
  COLOR_PURPLE_95,
  COLOR_RED_10,
  COLOR_RED_15,
  COLOR_RED_20,
  COLOR_RED_40,
  COLOR_RED_50,
  COLOR_RED_60,
  COLOR_RED_70,
  COLOR_RED_80,
  COLOR_RED_90,
  COLOR_RED_95,
  COLOR_TEAL_10,
  COLOR_TEAL_15,
  COLOR_TEAL_20,
  COLOR_TEAL_40,
  COLOR_TEAL_50,
  COLOR_TEAL_60,
  COLOR_TEAL_70,
  COLOR_TEAL_80,
  COLOR_TEAL_90,
  COLOR_TEAL_95,
  COLOR_WHITE,
  COLOR_YELLOW_ORANGE_10,
  COLOR_YELLOW_ORANGE_15,
  COLOR_YELLOW_ORANGE_20,
  COLOR_YELLOW_ORANGE_40,
  COLOR_YELLOW_ORANGE_50,
  COLOR_YELLOW_ORANGE_60,
  COLOR_YELLOW_ORANGE_70,
  COLOR_YELLOW_ORANGE_80,
  COLOR_YELLOW_ORANGE_90,
  COLOR_YELLOW_ORANGE_95,
  FONT_SIZE_BASE,
  GRADIENT_DARK_ACCENT_BOOST_GRADIENT,
  GRADIENT_DARK_ACCENT_BRAND_GRADIENT,
  GRADIENT_DARK_ACCENT_EXPLORE_GRADIENT,
  GRADIENT_DARK_ACCENT_FESTIVAL_MODE_GRADIENT,
  GRADIENT_DARK_ACCENT_GOLD_GRADIENT,
  GRADIENT_DARK_ACCENT_GOLD_SHINE_GRADIENT,
  GRADIENT_DARK_ACCENT_HOT_TAKES_GRADIENT,
  GRADIENT_DARK_ACCENT_LIKE_GRADIENT,
  GRADIENT_DARK_ACCENT_MATCHMAKER_GRADIENT,
  GRADIENT_DARK_ACCENT_MATCH_EXPIRATION_GRADIENT,
  GRADIENT_DARK_ACCENT_NOPE_GRADIENT,
  GRADIENT_DARK_ACCENT_PASSIONS_GRADIENT,
  GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT,
  GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT_INVERSE,
  GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT,
  GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT_INVERSE,
  GRADIENT_DARK_ACCENT_PRIMARY_GRADIENT,
  GRADIENT_DARK_ACCENT_REWIND_GRADIENT,
  GRADIENT_DARK_ACCENT_SELECT_GRADIENT,
  GRADIENT_DARK_ACCENT_SPARKS_BOOST_GRADIENT,
  GRADIENT_DARK_ACCENT_SPARKS_LIKE_GRADIENT,
  GRADIENT_DARK_ACCENT_SPARKS_NOPE_GRADIENT,
  GRADIENT_DARK_ACCENT_SPARKS_REWIND_GRADIENT,
  GRADIENT_DARK_ACCENT_SPARKS_SUPER_LIKE_GRADIENT,
  GRADIENT_DARK_ACCENT_SPOTIFY_MUSIC_MODE_GRADIENT,
  GRADIENT_DARK_ACCENT_SUPER_BOOST_GRADIENT,
  GRADIENT_DARK_ACCENT_SUPER_LIKE_GRADIENT,
  GRADIENT_DARK_ACCENT_VIBES_GRADIENT,
  GRADIENT_DARK_BACKGROUND_BOOST,
  GRADIENT_DARK_BACKGROUND_BOOST_INVERSE,
  GRADIENT_DARK_BACKGROUND_BOOST_SUBTLE,
  GRADIENT_DARK_BACKGROUND_BRAND_GRADIENT,
  GRADIENT_DARK_BACKGROUND_BRAND_SUBTLE,
  GRADIENT_DARK_BACKGROUND_BUTTON_PRIMARY,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_1,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_2,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_3,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_1,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_2,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_3,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_ICEBREAKER,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_PROMPT,
  GRADIENT_DARK_BACKGROUND_CARD_SPARKS_QUIZ,
  GRADIENT_DARK_BACKGROUND_EXPLORE_ATTRIBUTION,
  GRADIENT_DARK_BACKGROUND_FESTIVAL_MODE,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_BOOST_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_LIKE_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_NOPE_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_REWIND_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_BOOST_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_LIKE_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_NOPE_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_REWIND_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_PRESSED,
  GRADIENT_DARK_BACKGROUND_GAMEPAD_SUPER_LIKE_PRESSED,
  GRADIENT_DARK_BACKGROUND_GOLD,
  GRADIENT_DARK_BACKGROUND_GOLD_INVERSE,
  GRADIENT_DARK_BACKGROUND_GOLD_SHINE,
  GRADIENT_DARK_BACKGROUND_GOLD_SHINE_INVERSE,
  GRADIENT_DARK_BACKGROUND_GOLD_SUBTLE,
  GRADIENT_DARK_BACKGROUND_HOT_TAKES,
  GRADIENT_DARK_BACKGROUND_ICON_BUTTON_PRIMARY,
  GRADIENT_DARK_BACKGROUND_LIKE,
  GRADIENT_DARK_BACKGROUND_LIKE_INVERSE,
  GRADIENT_DARK_BACKGROUND_LIKE_SUBTLE,
  GRADIENT_DARK_BACKGROUND_MATCH_EXPIRATION,
  GRADIENT_DARK_BACKGROUND_NOPE,
  GRADIENT_DARK_BACKGROUND_NOPE_INVERSE,
  GRADIENT_DARK_BACKGROUND_PASSIONS_SHARED_REC,
  GRADIENT_DARK_BACKGROUND_PASSIONS_SPARKS_SHARED_OVERLAY,
  GRADIENT_DARK_BACKGROUND_PLATINUM,
  GRADIENT_DARK_BACKGROUND_PLATINUM_INVERSE,
  GRADIENT_DARK_BACKGROUND_PLATINUM_SHINE,
  GRADIENT_DARK_BACKGROUND_PLATINUM_SHINE_INVERSE,
  GRADIENT_DARK_BACKGROUND_PLATINUM_SUBTLE,
  GRADIENT_DARK_BACKGROUND_PLUS_SUBTLE,
  GRADIENT_DARK_BACKGROUND_PRIMARY_LINEAR,
  GRADIENT_DARK_BACKGROUND_REC_CARD_BOTTOM_AI_GRADIENT,
  GRADIENT_DARK_BACKGROUND_REWIND,
  GRADIENT_DARK_BACKGROUND_REWIND_INVERSE,
  GRADIENT_DARK_BACKGROUND_SCRIPTED_ONBOARDING,
  GRADIENT_DARK_BACKGROUND_SELECT_SUBTLE,
  GRADIENT_DARK_BACKGROUND_SPARKS_BOOST,
  GRADIENT_DARK_BACKGROUND_SPARKS_LIKE,
  GRADIENT_DARK_BACKGROUND_SPARKS_NOPE,
  GRADIENT_DARK_BACKGROUND_SPARKS_PRIMARY,
  GRADIENT_DARK_BACKGROUND_SPARKS_REWIND,
  GRADIENT_DARK_BACKGROUND_SPARKS_SUPER_LIKE,
  GRADIENT_DARK_BACKGROUND_SPOTIFY_MUSIC_MODE,
  GRADIENT_DARK_BACKGROUND_SUPER_BOOST,
  GRADIENT_DARK_BACKGROUND_SUPER_BOOST_INVERSE,
  GRADIENT_DARK_BACKGROUND_SUPER_BOOST_SUBTLE,
  GRADIENT_DARK_BACKGROUND_SUPER_LIKE,
  GRADIENT_DARK_BACKGROUND_SUPER_LIKE_INVERSE,
  GRADIENT_DARK_BACKGROUND_SUPER_LIKE_SUBTLE,
  GRADIENT_DARK_BACKGROUND_SWIPESURGE,
  GRADIENT_DARK_BACKGROUND_TEAL_SUBTLE,
  GRADIENT_DARK_BACKGROUND_VAULT_GRADIENT,
  GRADIENT_DARK_BACKGROUND_VAULT_SUBTLE,
  GRADIENT_DARK_BORDER_BRAND_GRADIENT,
  GRADIENT_DARK_BORDER_MATCH_EXPIRATION,
  GRADIENT_DARK_BORDER_SPARKS_PROMPT_SELECTED,
  GRADIENT_DARK_BORDER_VAULT_GRADIENT,
  GRADIENT_DARK_FADE_PRIMARY_BOTTOM_TO_TOP,
  GRADIENT_DARK_FADE_PRIMARY_TOP_TO_BOTTOM,
  GRADIENT_DARK_FOREGROUND_PROGRESS_ACTIVE,
  GRADIENT_DARK_ICON_BOOST,
  GRADIENT_DARK_ICON_BRAND_GRADIENT,
  GRADIENT_DARK_ICON_CHAT_DRAWER_VIBES_ACTIVE,
  GRADIENT_DARK_ICON_CONTAINER_BANNER_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_BOOST_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_LIKE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_NOPE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_REWIND_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_BOOST_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_LIKE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_NOPE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_REWIND_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_SUPER_LIKE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SPARKS_BOOST_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SPARKS_LIKE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SPARKS_NOPE_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SPARKS_REWIND_DEFAULT,
  GRADIENT_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT,
  GRADIENT_DARK_ICON_GOLD,
  GRADIENT_DARK_ICON_LIKE,
  GRADIENT_DARK_ICON_MATCH_EXPIRATION,
  GRADIENT_DARK_ICON_NAVIGATION_PRIMARY_ACTIVE,
  GRADIENT_DARK_ICON_NOPE,
  GRADIENT_DARK_ICON_PLATINUM,
  GRADIENT_DARK_ICON_REWIND,
  GRADIENT_DARK_ICON_SPARKS_BOOST,
  GRADIENT_DARK_ICON_SPARKS_LIKE,
  GRADIENT_DARK_ICON_SPARKS_MATCHMAKER_ATTRIBUTION,
  GRADIENT_DARK_ICON_SPARKS_NOPE,
  GRADIENT_DARK_ICON_SPARKS_REWIND,
  GRADIENT_DARK_ICON_SPARKS_SUPER_LIKE,
  GRADIENT_DARK_ICON_SUPERLIKE,
  GRADIENT_DARK_ICON_VAULT_GRADIENT,
  GRADIENT_DARK_OVERLAY_CARD,
  GRADIENT_DARK_OVERLAY_PRIMARY_GRADIENT,
  GRADIENT_DARK_OVERLAY_PROFILE_BUTTON_GAMEPAD,
  GRADIENT_DARK_OVERLAY_PROFILE_SPARKS_SUPER_LIKE,
  GRADIENT_DARK_OVERLAY_REC_CARD_DEFAULT,
  GRADIENT_DARK_OVERLAY_REC_CARD_HIGHLIGHT,
  GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_A,
  GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_B,
  GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_C,
  GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_D,
  GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_E,
  GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_F,
  GRADIENT_DARK_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE,
  GRADIENT_DARK_OVERLAY_REC_CARD_SUPER_LIKE,
  GRADIENT_DARK_OVERLAY_REC_CARD_VAULT,
  GRADIENT_DARK_OVERLAY_SECONDARY_GRADIENT,
  GRADIENT_DARK_OVERLAY_SUBTLE_CARD,
  GRADIENT_DARK_SHIMMER_GOLD,
  GRADIENT_DARK_SHIMMER_PLATINUM,
  GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_LIKE,
  GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_NOPE,
  GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE,
  GRADIENT_DARK_TEXT_MATCH_EXPIRATION,
  GRADIENT_DARK_TEXT_SPARKS_MATCHMAKER_ATTRIBUTION,
} from '../constants';
import THEME_DEFAULT from './default';

export default {
  ...THEME_DEFAULT,
  version: '10.19.0',
  themeId: 'dark',
  name: 'Dark Mode',
  dark: true,
  color: {
    ...THEME_DEFAULT.color,
    accentActive: COLOR_DARK_ACCENT_ACTIVE,
    accentBlue: COLOR_DARK_ACCENT_BLUE,
    accentBoost: COLOR_DARK_ACCENT_BOOST,
    accentBrand: COLOR_DARK_ACCENT_BRAND,
    accentChat: COLOR_DARK_ACCENT_CHAT,
    accentError: COLOR_DARK_ACCENT_ERROR,
    accentFuchsia: COLOR_DARK_ACCENT_FUCHSIA,
    accentGold: COLOR_DARK_ACCENT_GOLD,
    accentGreen: COLOR_DARK_ACCENT_GREEN,
    accentLike: COLOR_DARK_ACCENT_LIKE,
    accentLink: COLOR_DARK_ACCENT_LINK,
    accentNope: COLOR_DARK_ACCENT_NOPE,
    accentPlatinum: COLOR_DARK_ACCENT_PLATINUM,
    accentPrimary: COLOR_DARK_ACCENT_PRIMARY,
    accentPrimaryA11y: COLOR_DARK_ACCENT_PRIMARY_A11Y,
    accentPurple: COLOR_DARK_ACCENT_PURPLE,
    accentRed: COLOR_DARK_ACCENT_RED,
    accentRewind: COLOR_DARK_ACCENT_REWIND,
    accentSelect: COLOR_DARK_ACCENT_SELECT,
    accentSuccess: COLOR_DARK_ACCENT_SUCCESS,
    accentSuperLike: COLOR_DARK_ACCENT_SUPER_LIKE,
    accentTeal: COLOR_DARK_ACCENT_TEAL,
    accentTrust: COLOR_DARK_ACCENT_TRUST,
    accentYellowOrange: COLOR_DARK_ACCENT_YELLOW_ORANGE,
    actionActive: COLOR_DARK_ACTION_ACTIVE,
    actionInactive: COLOR_DARK_ACTION_INACTIVE,
    actionNavigationSecondaryDisabled: COLOR_DARK_ACTION_NAVIGATION_SECONDARY_DISABLED,
    actionTextFieldLoudActive: COLOR_DARK_ACTION_TEXT_FIELD_LOUD_ACTIVE,
    actionTextFieldLoudInactive: COLOR_DARK_ACTION_TEXT_FIELD_LOUD_INACTIVE,
    actionTextFieldQuietActive: COLOR_DARK_ACTION_TEXT_FIELD_QUIET_ACTIVE,
    actionTextFieldQuietInactive: COLOR_DARK_ACTION_TEXT_FIELD_QUIET_INACTIVE,
    backgroundBadgeBrandDefault: COLOR_DARK_BACKGROUND_BADGE_BRAND_DEFAULT,
    backgroundBadgeNotificationActive: COLOR_DARK_BACKGROUND_BADGE_NOTIFICATION_ACTIVE,
    backgroundBadgeNotificationInactive: COLOR_DARK_BACKGROUND_BADGE_NOTIFICATION_INACTIVE,
    backgroundBadgeOnlineNowDefault: COLOR_DARK_BACKGROUND_BADGE_ONLINE_NOW_DEFAULT,
    backgroundBadgeVerifiedDefault: COLOR_DARK_BACKGROUND_BADGE_VERIFIED_DEFAULT,
    backgroundBannerDefault: COLOR_DARK_BACKGROUND_BANNER_DEFAULT,
    backgroundBlue: COLOR_DARK_BACKGROUND_BLUE,
    backgroundBottomSheetDefault: COLOR_DARK_BACKGROUND_BOTTOM_SHEET_DEFAULT,
    backgroundBrand: COLOR_DARK_BACKGROUND_BRAND,
    backgroundButtonDisabled: COLOR_DARK_BACKGROUND_BUTTON_DISABLED,
    backgroundButtonElevated: COLOR_DARK_BACKGROUND_BUTTON_ELEVATED,
    backgroundButtonNeutral: COLOR_DARK_BACKGROUND_BUTTON_NEUTRAL,
    backgroundButtonPrimaryOverlay: COLOR_DARK_BACKGROUND_BUTTON_PRIMARY_OVERLAY,
    backgroundButtonPrimarySmall: COLOR_DARK_BACKGROUND_BUTTON_PRIMARY_SMALL,
    backgroundButtonSparksExpandProfile: COLOR_DARK_BACKGROUND_BUTTON_SPARKS_EXPAND_PROFILE,
    backgroundButtonSparksNeutral: COLOR_DARK_BACKGROUND_BUTTON_SPARKS_NEUTRAL,
    backgroundCardDefault: COLOR_DARK_BACKGROUND_CARD_DEFAULT,
    backgroundCardSparks: COLOR_DARK_BACKGROUND_CARD_SPARKS,
    backgroundChatBubbleReceive: COLOR_DARK_BACKGROUND_CHAT_BUBBLE_RECEIVE,
    backgroundChatBubbleSend: COLOR_DARK_BACKGROUND_CHAT_BUBBLE_SEND,
    backgroundCheckboxDisabled: COLOR_DARK_BACKGROUND_CHECKBOX_DISABLED,
    backgroundCheckboxSelectedEnabled: COLOR_DARK_BACKGROUND_CHECKBOX_SELECTED_ENABLED,
    backgroundDatepickerSelected: COLOR_DARK_BACKGROUND_DATEPICKER_SELECTED,
    backgroundDisabled: COLOR_DARK_BACKGROUND_DISABLED,
    backgroundElevated: COLOR_DARK_BACKGROUND_ELEVATED,
    backgroundError: COLOR_DARK_BACKGROUND_ERROR,
    backgroundFuchsia: COLOR_DARK_BACKGROUND_FUCHSIA,
    backgroundGamepadPrimaryDefault: COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DEFAULT,
    backgroundGamepadPrimaryDisabled: COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DISABLED,
    backgroundGamepadPrimaryDisabledOnSuperLike:
      COLOR_DARK_BACKGROUND_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE,
    backgroundGamepadSecondaryDefault: COLOR_DARK_BACKGROUND_GAMEPAD_SECONDARY_DEFAULT,
    backgroundGamepadSecondaryDisabled: COLOR_DARK_BACKGROUND_GAMEPAD_SECONDARY_DISABLED,
    backgroundGamepadSparksBoostDefault: COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_BOOST_DEFAULT,
    backgroundGamepadSparksLikeDefault: COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_LIKE_DEFAULT,
    backgroundGamepadSparksNopeDefault: COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_NOPE_DEFAULT,
    backgroundGamepadSparksRewindDefault: COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_REWIND_DEFAULT,
    backgroundGamepadSparksSuperLikeDefault:
      COLOR_DARK_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT,
    backgroundGreen: COLOR_DARK_BACKGROUND_GREEN,
    backgroundHeaderSparks: COLOR_DARK_BACKGROUND_HEADER_SPARKS,
    backgroundIconButtonDisabled: COLOR_DARK_BACKGROUND_ICON_BUTTON_DISABLED,
    backgroundIconButtonOverlayDefault: COLOR_DARK_BACKGROUND_ICON_BUTTON_OVERLAY_DEFAULT,
    backgroundIconButtonOverlayDisabled: COLOR_DARK_BACKGROUND_ICON_BUTTON_OVERLAY_DISABLED,
    backgroundIconButtonSecondary: COLOR_DARK_BACKGROUND_ICON_BUTTON_SECONDARY,
    backgroundInactive: COLOR_DARK_BACKGROUND_INACTIVE,
    backgroundMenuDefault: COLOR_DARK_BACKGROUND_MENU_DEFAULT,
    backgroundModalContainerDefault: COLOR_DARK_BACKGROUND_MODAL_CONTAINER_DEFAULT,
    backgroundModalOverlayDefault: COLOR_DARK_BACKGROUND_MODAL_OVERLAY_DEFAULT,
    backgroundModalOverlayRecs: COLOR_DARK_BACKGROUND_MODAL_OVERLAY_RECS,
    backgroundOverlayPrimary: COLOR_DARK_BACKGROUND_OVERLAY_PRIMARY,
    backgroundOverlaySecondary: COLOR_DARK_BACKGROUND_OVERLAY_SECONDARY,
    backgroundPassionsEdit: COLOR_DARK_BACKGROUND_PASSIONS_EDIT,
    backgroundPassionsInactiveOverlay: COLOR_DARK_BACKGROUND_PASSIONS_INACTIVE_OVERLAY,
    backgroundPassionsShared: COLOR_DARK_BACKGROUND_PASSIONS_SHARED,
    backgroundPassionsSharedOverlay: COLOR_DARK_BACKGROUND_PASSIONS_SHARED_OVERLAY,
    backgroundPassionsSparksInactive: COLOR_DARK_BACKGROUND_PASSIONS_SPARKS_INACTIVE,
    backgroundPassionsSparksInactiveOverlay: COLOR_DARK_BACKGROUND_PASSIONS_SPARKS_INACTIVE_OVERLAY,
    backgroundPrimary: COLOR_DARK_BACKGROUND_PRIMARY,
    backgroundPrimaryInverse: COLOR_DARK_BACKGROUND_PRIMARY_INVERSE,
    backgroundPrimaryStaticDark: COLOR_DARK_BACKGROUND_PRIMARY_STATIC_DARK,
    backgroundPrimaryStaticLight: COLOR_DARK_BACKGROUND_PRIMARY_STATIC_LIGHT,
    backgroundProgressInactive: COLOR_DARK_BACKGROUND_PROGRESS_INACTIVE,
    backgroundPurple: COLOR_DARK_BACKGROUND_PURPLE,
    backgroundRadioSelectedDisabled: COLOR_DARK_BACKGROUND_RADIO_SELECTED_DISABLED,
    backgroundRadioSelectedEnabled: COLOR_DARK_BACKGROUND_RADIO_SELECTED_ENABLED,
    backgroundRadioUnselectedDisabled: COLOR_DARK_BACKGROUND_RADIO_UNSELECTED_DISABLED,
    backgroundReadReceiptsBadge: COLOR_DARK_BACKGROUND_READ_RECEIPTS_BADGE,
    backgroundRecCardBottomDefault: COLOR_DARK_BACKGROUND_REC_CARD_BOTTOM_DEFAULT,
    backgroundRecCardBottomSuperLike: COLOR_DARK_BACKGROUND_REC_CARD_BOTTOM_SUPER_LIKE,
    backgroundRecCardContentHidden: COLOR_DARK_BACKGROUND_REC_CARD_CONTENT_HIDDEN,
    backgroundRed: COLOR_DARK_BACKGROUND_RED,
    backgroundRippleDefault: COLOR_DARK_BACKGROUND_RIPPLE_DEFAULT,
    backgroundSearchDefault: COLOR_DARK_BACKGROUND_SEARCH_DEFAULT,
    backgroundSecondary: COLOR_DARK_BACKGROUND_SECONDARY,
    backgroundSecondaryInverse: COLOR_DARK_BACKGROUND_SECONDARY_INVERSE,
    backgroundSecondaryStaticDark: COLOR_DARK_BACKGROUND_SECONDARY_STATIC_DARK,
    backgroundSecondaryStaticLight: COLOR_DARK_BACKGROUND_SECONDARY_STATIC_LIGHT,
    backgroundSliderAltFillDisabled: COLOR_DARK_BACKGROUND_SLIDER_ALT_FILL_DISABLED,
    backgroundSliderAltFillEnabled: COLOR_DARK_BACKGROUND_SLIDER_ALT_FILL_ENABLED,
    backgroundSliderAltKnobDisabled: COLOR_DARK_BACKGROUND_SLIDER_ALT_KNOB_DISABLED,
    backgroundSliderAltKnobEnabled: COLOR_DARK_BACKGROUND_SLIDER_ALT_KNOB_ENABLED,
    backgroundSliderAltTrackDisabled: COLOR_DARK_BACKGROUND_SLIDER_ALT_TRACK_DISABLED,
    backgroundSliderAltTrackEnabled: COLOR_DARK_BACKGROUND_SLIDER_ALT_TRACK_ENABLED,
    backgroundSliderDefaultFillDisabled: COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_FILL_DISABLED,
    backgroundSliderDefaultFillEnabled: COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_FILL_ENABLED,
    backgroundSliderDefaultKnobDisabled: COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_KNOB_DISABLED,
    backgroundSliderDefaultKnobEnabled: COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_KNOB_ENABLED,
    backgroundSliderDefaultTrackDisabled: COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_TRACK_DISABLED,
    backgroundSliderDefaultTrackEnabled: COLOR_DARK_BACKGROUND_SLIDER_DEFAULT_TRACK_ENABLED,
    backgroundSparksBottomNav: COLOR_DARK_BACKGROUND_SPARKS_BOTTOM_NAV,
    backgroundSparksProfile: COLOR_DARK_BACKGROUND_SPARKS_PROFILE,
    backgroundSparksPrompt: COLOR_DARK_BACKGROUND_SPARKS_PROMPT,
    backgroundSparksTopNav: COLOR_DARK_BACKGROUND_SPARKS_TOP_NAV,
    backgroundSwitchAltKnobDisabled: COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_DISABLED,
    backgroundSwitchAltKnobSelected: COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_SELECTED,
    backgroundSwitchAltKnobUnselected: COLOR_DARK_BACKGROUND_SWITCH_ALT_KNOB_UNSELECTED,
    backgroundSwitchAltTrackDisabled: COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_DISABLED,
    backgroundSwitchAltTrackSelected: COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_SELECTED,
    backgroundSwitchAltTrackUnselected: COLOR_DARK_BACKGROUND_SWITCH_ALT_TRACK_UNSELECTED,
    backgroundSwitchDefaultKnobDisabled: COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_DISABLED,
    backgroundSwitchDefaultKnobSelected: COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_SELECTED,
    backgroundSwitchDefaultKnobUnselected: COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_KNOB_UNSELECTED,
    backgroundSwitchDefaultTrackDisabled: COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_DISABLED,
    backgroundSwitchDefaultTrackSelected: COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_SELECTED,
    backgroundSwitchDefaultTrackUnselected: COLOR_DARK_BACKGROUND_SWITCH_DEFAULT_TRACK_UNSELECTED,
    backgroundTableRowDefault: COLOR_DARK_BACKGROUND_TABLE_ROW_DEFAULT,
    backgroundTableRowHover: COLOR_DARK_BACKGROUND_TABLE_ROW_HOVER,
    backgroundTableRowPressed: COLOR_DARK_BACKGROUND_TABLE_ROW_PRESSED,
    backgroundTappyContainerDefault: COLOR_DARK_BACKGROUND_TAPPY_CONTAINER_DEFAULT,
    backgroundTappyIndicatorActive: COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_ACTIVE,
    backgroundTappyIndicatorInactive: COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_INACTIVE,
    backgroundTappyIndicatorSparksActive: COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_SPARKS_ACTIVE,
    backgroundTappyIndicatorSparksInactive: COLOR_DARK_BACKGROUND_TAPPY_INDICATOR_SPARKS_INACTIVE,
    backgroundTappySparks: COLOR_DARK_BACKGROUND_TAPPY_SPARKS,
    backgroundTeal: COLOR_DARK_BACKGROUND_TEAL,
    backgroundTertiary: COLOR_DARK_BACKGROUND_TERTIARY,
    backgroundTertiaryInverse: COLOR_DARK_BACKGROUND_TERTIARY_INVERSE,
    backgroundTextFieldLoudDefault: COLOR_DARK_BACKGROUND_TEXT_FIELD_LOUD_DEFAULT,
    backgroundTextFieldLoudHighlight: COLOR_DARK_BACKGROUND_TEXT_FIELD_LOUD_HIGHLIGHT,
    backgroundTextFieldQuietDefault: COLOR_DARK_BACKGROUND_TEXT_FIELD_QUIET_DEFAULT,
    backgroundTextFieldQuietHighlight: COLOR_DARK_BACKGROUND_TEXT_FIELD_QUIET_HIGHLIGHT,
    backgroundToastDefault: COLOR_DARK_BACKGROUND_TOAST_DEFAULT,
    backgroundTooltipDefault: COLOR_DARK_BACKGROUND_TOOLTIP_DEFAULT,
    backgroundTooltipRevenueDefault: COLOR_DARK_BACKGROUND_TOOLTIP_REVENUE_DEFAULT,
    backgroundTooltipTrustDefault: COLOR_DARK_BACKGROUND_TOOLTIP_TRUST_DEFAULT,
    backgroundTrust: COLOR_DARK_BACKGROUND_TRUST,
    backgroundVault: COLOR_DARK_BACKGROUND_VAULT,
    backgroundYellowOrange: COLOR_DARK_BACKGROUND_YELLOW_ORANGE,
    borderActive: COLOR_DARK_BORDER_ACTIVE,
    borderBoost: COLOR_DARK_BORDER_BOOST,
    borderBrand: COLOR_DARK_BORDER_BRAND,
    borderButtonFocused: COLOR_DARK_BORDER_BUTTON_FOCUSED,
    borderButtonFocusedOverlay: COLOR_DARK_BORDER_BUTTON_FOCUSED_OVERLAY,
    borderButtonSecondary: COLOR_DARK_BORDER_BUTTON_SECONDARY,
    borderButtonSecondaryOverlay: COLOR_DARK_BORDER_BUTTON_SECONDARY_OVERLAY,
    borderButtonSparksExpandProfile: COLOR_DARK_BORDER_BUTTON_SPARKS_EXPAND_PROFILE,
    borderCard: COLOR_DARK_BORDER_CARD,
    borderCheckboxUnselectedDisabled: COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_DISABLED,
    borderCheckboxUnselectedEnabled: COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_ENABLED,
    borderCheckboxUnselectedError: COLOR_DARK_BORDER_CHECKBOX_UNSELECTED_ERROR,
    borderContainerElevated: COLOR_DARK_BORDER_CONTAINER_ELEVATED,
    borderDisabled: COLOR_DARK_BORDER_DISABLED,
    borderError: COLOR_DARK_BORDER_ERROR,
    borderFocusDefault: COLOR_DARK_BORDER_FOCUS_DEFAULT,
    borderFocusInverse: COLOR_DARK_BORDER_FOCUS_INVERSE,
    borderFocusOverlay: COLOR_DARK_BORDER_FOCUS_OVERLAY,
    borderGamepadBoostDefault: COLOR_DARK_BORDER_GAMEPAD_BOOST_DEFAULT,
    borderGamepadLikeDefault: COLOR_DARK_BORDER_GAMEPAD_LIKE_DEFAULT,
    borderGamepadNopeDefault: COLOR_DARK_BORDER_GAMEPAD_NOPE_DEFAULT,
    borderGamepadPrimaryDisabled: COLOR_DARK_BORDER_GAMEPAD_PRIMARY_DISABLED,
    borderGamepadPrimaryDisabledOnSuperLike:
      COLOR_DARK_BORDER_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE,
    borderGamepadRewindDefault: COLOR_DARK_BORDER_GAMEPAD_REWIND_DEFAULT,
    borderGamepadSecondaryDisabled: COLOR_DARK_BORDER_GAMEPAD_SECONDARY_DISABLED,
    borderGamepadSparksBoostDefault: COLOR_DARK_BORDER_GAMEPAD_SPARKS_BOOST_DEFAULT,
    borderGamepadSparksLikeDefault: COLOR_DARK_BORDER_GAMEPAD_SPARKS_LIKE_DEFAULT,
    borderGamepadSparksNopeDefault: COLOR_DARK_BORDER_GAMEPAD_SPARKS_NOPE_DEFAULT,
    borderGamepadSparksRewindDefault: COLOR_DARK_BORDER_GAMEPAD_SPARKS_REWIND_DEFAULT,
    borderGamepadSparksSuperLikeDefault: COLOR_DARK_BORDER_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT,
    borderGamepadSuperLikeActive: COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_ACTIVE,
    borderGamepadSuperLikeDefault: COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_DEFAULT,
    borderGamepadSuperLikeDisabled: COLOR_DARK_BORDER_GAMEPAD_SUPER_LIKE_DISABLED,
    borderGold: COLOR_DARK_BORDER_GOLD,
    borderIconButtonDisabled: COLOR_DARK_BORDER_ICON_BUTTON_DISABLED,
    borderIconButtonPrimary: COLOR_DARK_BORDER_ICON_BUTTON_PRIMARY,
    borderIconButtonSecondary: COLOR_DARK_BORDER_ICON_BUTTON_SECONDARY,
    borderLike: COLOR_DARK_BORDER_LIKE,
    borderNope: COLOR_DARK_BORDER_NOPE,
    borderOverlay: COLOR_DARK_BORDER_OVERLAY,
    borderPassionsActive: COLOR_DARK_BORDER_PASSIONS_ACTIVE,
    borderPassionsInactive: COLOR_DARK_BORDER_PASSIONS_INACTIVE,
    borderPassionsShared: COLOR_DARK_BORDER_PASSIONS_SHARED,
    borderPassionsSharedOverlay: COLOR_DARK_BORDER_PASSIONS_SHARED_OVERLAY,
    borderPlatinum: COLOR_DARK_BORDER_PLATINUM,
    borderPrimary: COLOR_DARK_BORDER_PRIMARY,
    borderPrimaryInverse: COLOR_DARK_BORDER_PRIMARY_INVERSE,
    borderRadioSelectedDisabled: COLOR_DARK_BORDER_RADIO_SELECTED_DISABLED,
    borderRadioSelectedEnabled: COLOR_DARK_BORDER_RADIO_SELECTED_ENABLED,
    borderRadioUnselectedDisabled: COLOR_DARK_BORDER_RADIO_UNSELECTED_DISABLED,
    borderRadioUnselectedEnabled: COLOR_DARK_BORDER_RADIO_UNSELECTED_ENABLED,
    borderRecCardContentHidden: COLOR_DARK_BORDER_REC_CARD_CONTENT_HIDDEN,
    borderRewind: COLOR_DARK_BORDER_REWIND,
    borderSecondary: COLOR_DARK_BORDER_SECONDARY,
    borderSecondaryOverlay: COLOR_DARK_BORDER_SECONDARY_OVERLAY,
    borderSliderAltKnobDisabled: COLOR_DARK_BORDER_SLIDER_ALT_KNOB_DISABLED,
    borderSliderAltKnobEnabled: COLOR_DARK_BORDER_SLIDER_ALT_KNOB_ENABLED,
    borderSliderDefaultKnobDisabled: COLOR_DARK_BORDER_SLIDER_DEFAULT_KNOB_DISABLED,
    borderSliderDefaultKnobEnabled: COLOR_DARK_BORDER_SLIDER_DEFAULT_KNOB_ENABLED,
    borderSparksBoost: COLOR_DARK_BORDER_SPARKS_BOOST,
    borderSparksLike: COLOR_DARK_BORDER_SPARKS_LIKE,
    borderSparksNope: COLOR_DARK_BORDER_SPARKS_NOPE,
    borderSparksRewind: COLOR_DARK_BORDER_SPARKS_REWIND,
    borderSparksSuperLike: COLOR_DARK_BORDER_SPARKS_SUPER_LIKE,
    borderSuccess: COLOR_DARK_BORDER_SUCCESS,
    borderSuperLike: COLOR_DARK_BORDER_SUPER_LIKE,
    borderSwitchAltKnobDisabled: COLOR_DARK_BORDER_SWITCH_ALT_KNOB_DISABLED,
    borderSwitchAltKnobSelected: COLOR_DARK_BORDER_SWITCH_ALT_KNOB_SELECTED,
    borderSwitchAltKnobUnselected: COLOR_DARK_BORDER_SWITCH_ALT_KNOB_UNSELECTED,
    borderSwitchAltTrackDisabled: COLOR_DARK_BORDER_SWITCH_ALT_TRACK_DISABLED,
    borderSwitchAltTrackSelected: COLOR_DARK_BORDER_SWITCH_ALT_TRACK_SELECTED,
    borderSwitchAltTrackUnselected: COLOR_DARK_BORDER_SWITCH_ALT_TRACK_UNSELECTED,
    borderSwitchDefaultKnobDisabled: COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_DISABLED,
    borderSwitchDefaultKnobSelected: COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_SELECTED,
    borderSwitchDefaultKnobUnselected: COLOR_DARK_BORDER_SWITCH_DEFAULT_KNOB_UNSELECTED,
    borderSwitchDefaultTrackDisabled: COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_DISABLED,
    borderSwitchDefaultTrackSelected: COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_SELECTED,
    borderSwitchDefaultTrackUnselected: COLOR_DARK_BORDER_SWITCH_DEFAULT_TRACK_UNSELECTED,
    borderTappyIndicatorActive: COLOR_DARK_BORDER_TAPPY_INDICATOR_ACTIVE,
    borderTappyIndicatorInactive: COLOR_DARK_BORDER_TAPPY_INDICATOR_INACTIVE,
    borderTappyIndicatorSparksActive: COLOR_DARK_BORDER_TAPPY_INDICATOR_SPARKS_ACTIVE,
    borderTappyIndicatorSparksInactive: COLOR_DARK_BORDER_TAPPY_INDICATOR_SPARKS_INACTIVE,
    borderTextFieldLoudDefault: COLOR_DARK_BORDER_TEXT_FIELD_LOUD_DEFAULT,
    borderTextFieldLoudDisabled: COLOR_DARK_BORDER_TEXT_FIELD_LOUD_DISABLED,
    borderTextFieldLoudError: COLOR_DARK_BORDER_TEXT_FIELD_LOUD_ERROR,
    borderTextFieldLoudFocus: COLOR_DARK_BORDER_TEXT_FIELD_LOUD_FOCUS,
    borderTextFieldQuietDefault: COLOR_DARK_BORDER_TEXT_FIELD_QUIET_DEFAULT,
    borderTextFieldQuietDisabled: COLOR_DARK_BORDER_TEXT_FIELD_QUIET_DISABLED,
    borderTextFieldQuietError: COLOR_DARK_BORDER_TEXT_FIELD_QUIET_ERROR,
    borderTextFieldQuietFocus: COLOR_DARK_BORDER_TEXT_FIELD_QUIET_FOCUS,
    borderTimerExpired: COLOR_DARK_BORDER_TIMER_EXPIRED,
    borderTooltipDefault: COLOR_DARK_BORDER_TOOLTIP_DEFAULT,
    borderTooltipRevenueBoost: COLOR_DARK_BORDER_TOOLTIP_REVENUE_BOOST,
    borderTooltipRevenueLike: COLOR_DARK_BORDER_TOOLTIP_REVENUE_LIKE,
    borderTooltipRevenueNope: COLOR_DARK_BORDER_TOOLTIP_REVENUE_NOPE,
    borderTooltipRevenueRewind: COLOR_DARK_BORDER_TOOLTIP_REVENUE_REWIND,
    borderTooltipRevenueSuperLike: COLOR_DARK_BORDER_TOOLTIP_REVENUE_SUPER_LIKE,
    borderVault: COLOR_DARK_BORDER_VAULT,
    cursorDefault: COLOR_DARK_CURSOR_DEFAULT,
    cursorSearchInput: COLOR_DARK_CURSOR_SEARCH_INPUT,
    cursorTextFieldLoudDefault: COLOR_DARK_CURSOR_TEXT_FIELD_LOUD_DEFAULT,
    cursorTextFieldQuietDefault: COLOR_DARK_CURSOR_TEXT_FIELD_QUIET_DEFAULT,
    deviceHomeIndicator: COLOR_DARK_DEVICE_HOME_INDICATOR,
    deviceStatusBar: COLOR_DARK_DEVICE_STATUS_BAR,
    deviceStatusBarInverse: COLOR_DARK_DEVICE_STATUS_BAR_INVERSE,
    dividerBannerDefault: COLOR_DARK_DIVIDER_BANNER_DEFAULT,
    dividerPrimary: COLOR_DARK_DIVIDER_PRIMARY,
    dividerSparks: COLOR_DARK_DIVIDER_SPARKS,
    dividerTableRowDefault: COLOR_DARK_DIVIDER_TABLE_ROW_DEFAULT,
    dividerTableRowSparks: COLOR_DARK_DIVIDER_TABLE_ROW_SPARKS,
    dividerTappySparks: COLOR_DARK_DIVIDER_TAPPY_SPARKS,
    foregroundBlue: COLOR_DARK_FOREGROUND_BLUE,
    foregroundBorderElevated: COLOR_DARK_FOREGROUND_BORDER_ELEVATED,
    foregroundBorderPrimary: COLOR_DARK_FOREGROUND_BORDER_PRIMARY,
    foregroundBorderSecondary: COLOR_DARK_FOREGROUND_BORDER_SECONDARY,
    foregroundButtonDisabled: COLOR_DARK_FOREGROUND_BUTTON_DISABLED,
    foregroundButtonNeutral: COLOR_DARK_FOREGROUND_BUTTON_NEUTRAL,
    foregroundButtonPrimary: COLOR_DARK_FOREGROUND_BUTTON_PRIMARY,
    foregroundButtonPrimaryOverlay: COLOR_DARK_FOREGROUND_BUTTON_PRIMARY_OVERLAY,
    foregroundButtonSecondary: COLOR_DARK_FOREGROUND_BUTTON_SECONDARY,
    foregroundButtonSecondaryOverlay: COLOR_DARK_FOREGROUND_BUTTON_SECONDARY_OVERLAY,
    foregroundButtonSparksExpandProfile: COLOR_DARK_FOREGROUND_BUTTON_SPARKS_EXPAND_PROFILE,
    foregroundButtonTertiary: COLOR_DARK_FOREGROUND_BUTTON_TERTIARY,
    foregroundButtonTertiaryOverlay: COLOR_DARK_FOREGROUND_BUTTON_TERTIARY_OVERLAY,
    foregroundDisabled: COLOR_DARK_FOREGROUND_DISABLED,
    foregroundFuchsia: COLOR_DARK_FOREGROUND_FUCHSIA,
    foregroundGreen: COLOR_DARK_FOREGROUND_GREEN,
    foregroundInactive: COLOR_DARK_FOREGROUND_INACTIVE,
    foregroundModalBody: COLOR_DARK_FOREGROUND_MODAL_BODY,
    foregroundModalHeading: COLOR_DARK_FOREGROUND_MODAL_HEADING,
    foregroundModalIcon: COLOR_DARK_FOREGROUND_MODAL_ICON,
    foregroundPrimary: COLOR_DARK_FOREGROUND_PRIMARY,
    foregroundPrimaryInverse: COLOR_DARK_FOREGROUND_PRIMARY_INVERSE,
    foregroundPrimaryStaticDark: COLOR_DARK_FOREGROUND_PRIMARY_STATIC_DARK,
    foregroundPrimaryStaticLight: COLOR_DARK_FOREGROUND_PRIMARY_STATIC_LIGHT,
    foregroundPrimaryStaticOnDark: COLOR_DARK_FOREGROUND_PRIMARY_STATIC_ON_DARK,
    foregroundPurple: COLOR_DARK_FOREGROUND_PURPLE,
    foregroundReadReceiptsBadge: COLOR_DARK_FOREGROUND_READ_RECEIPTS_BADGE,
    foregroundRed: COLOR_DARK_FOREGROUND_RED,
    foregroundSecondary: COLOR_DARK_FOREGROUND_SECONDARY,
    foregroundSecondaryInverse: COLOR_DARK_FOREGROUND_SECONDARY_INVERSE,
    foregroundSecondaryStaticDark: COLOR_DARK_FOREGROUND_SECONDARY_STATIC_DARK,
    foregroundSecondaryStaticLight: COLOR_DARK_FOREGROUND_SECONDARY_STATIC_LIGHT,
    foregroundTeal: COLOR_DARK_FOREGROUND_TEAL,
    foregroundYellowOrange: COLOR_DARK_FOREGROUND_YELLOW_ORANGE,
    iconBadgeVerified: COLOR_DARK_ICON_BADGE_VERIFIED,
    iconBannerDefault: COLOR_DARK_ICON_BANNER_DEFAULT,
    iconBannerDismiss: COLOR_DARK_ICON_BANNER_DISMISS,
    iconBrand: COLOR_DARK_ICON_BRAND,
    iconChatDrawerContactCardActive: COLOR_DARK_ICON_CHAT_DRAWER_CONTACT_CARD_ACTIVE,
    iconChatDrawerContactCardDefault: COLOR_DARK_ICON_CHAT_DRAWER_CONTACT_CARD_DEFAULT,
    iconChatDrawerGifBackgroundActive: COLOR_DARK_ICON_CHAT_DRAWER_GIF_BACKGROUND_ACTIVE,
    iconChatDrawerGifBackgroundDefault: COLOR_DARK_ICON_CHAT_DRAWER_GIF_BACKGROUND_DEFAULT,
    iconChatDrawerGifForegroundActive: COLOR_DARK_ICON_CHAT_DRAWER_GIF_FOREGROUND_ACTIVE,
    iconChatDrawerGifForegroundDefault: COLOR_DARK_ICON_CHAT_DRAWER_GIF_FOREGROUND_DEFAULT,
    iconChatDrawerNoonlightBackgroundActive:
      COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_ACTIVE,
    iconChatDrawerNoonlightBackgroundDefault:
      COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_BACKGROUND_DEFAULT,
    iconChatDrawerNoonlightForegroundActive:
      COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_ACTIVE,
    iconChatDrawerNoonlightForegroundDefault:
      COLOR_DARK_ICON_CHAT_DRAWER_NOONLIGHT_FOREGROUND_DEFAULT,
    iconChatDrawerSpotifyBackgroundActive: COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_ACTIVE,
    iconChatDrawerSpotifyBackgroundDefault: COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_BACKGROUND_DEFAULT,
    iconChatDrawerSpotifyForegroundActive: COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_ACTIVE,
    iconChatDrawerSpotifyForegroundDefault: COLOR_DARK_ICON_CHAT_DRAWER_SPOTIFY_FOREGROUND_DEFAULT,
    iconChatDrawerStickerActive: COLOR_DARK_ICON_CHAT_DRAWER_STICKER_ACTIVE,
    iconChatDrawerStickerDefault: COLOR_DARK_ICON_CHAT_DRAWER_STICKER_DEFAULT,
    iconChatDrawerVibesDefault: COLOR_DARK_ICON_CHAT_DRAWER_VIBES_DEFAULT,
    iconChatHeartActive: COLOR_DARK_ICON_CHAT_HEART_ACTIVE,
    iconChatHeartDefault: COLOR_DARK_ICON_CHAT_HEART_DEFAULT,
    iconCheckboxSelectedDisabled: COLOR_DARK_ICON_CHECKBOX_SELECTED_DISABLED,
    iconCheckboxSelectedEnabled: COLOR_DARK_ICON_CHECKBOX_SELECTED_ENABLED,
    iconDisabled: COLOR_DARK_ICON_DISABLED,
    iconError: COLOR_DARK_ICON_ERROR,
    iconFormDefault: COLOR_DARK_ICON_FORM_DEFAULT,
    iconFormDisabled: COLOR_DARK_ICON_FORM_DISABLED,
    iconFormError: COLOR_DARK_ICON_FORM_ERROR,
    iconFormSuccess: COLOR_DARK_ICON_FORM_SUCCESS,
    iconGamepadPrimaryDisabled: COLOR_DARK_ICON_GAMEPAD_PRIMARY_DISABLED,
    iconGamepadPrimaryDisabledOnSuperLike: COLOR_DARK_ICON_GAMEPAD_PRIMARY_DISABLED_ON_SUPER_LIKE,
    iconGamepadPrimaryPressed: COLOR_DARK_ICON_GAMEPAD_PRIMARY_PRESSED,
    iconGamepadPrimarySuperLikeActive: COLOR_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_ACTIVE,
    iconGamepadPrimarySuperLikeDisabled: COLOR_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DISABLED,
    iconGamepadSecondaryDisabled: COLOR_DARK_ICON_GAMEPAD_SECONDARY_DISABLED,
    iconGamepadSecondaryPressed: COLOR_DARK_ICON_GAMEPAD_SECONDARY_PRESSED,
    iconGamepadSparksBoostActive: COLOR_DARK_ICON_GAMEPAD_SPARKS_BOOST_ACTIVE,
    iconGamepadSparksLikeActive: COLOR_DARK_ICON_GAMEPAD_SPARKS_LIKE_ACTIVE,
    iconGamepadSparksNopeActive: COLOR_DARK_ICON_GAMEPAD_SPARKS_NOPE_ACTIVE,
    iconGamepadSparksRewindActive: COLOR_DARK_ICON_GAMEPAD_SPARKS_REWIND_ACTIVE,
    iconGamepadSparksSuperLikeActive: COLOR_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_ACTIVE,
    iconGamepadSparksSuperLikeDisabled: COLOR_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DISABLED,
    iconIconButtonDisabled: COLOR_DARK_ICON_ICON_BUTTON_DISABLED,
    iconIconButtonOverlayDefault: COLOR_DARK_ICON_ICON_BUTTON_OVERLAY_DEFAULT,
    iconIconButtonOverlayDisabled: COLOR_DARK_ICON_ICON_BUTTON_OVERLAY_DISABLED,
    iconIconButtonPrimary: COLOR_DARK_ICON_ICON_BUTTON_PRIMARY,
    iconIconButtonSecondary: COLOR_DARK_ICON_ICON_BUTTON_SECONDARY,
    iconNavigationPrimaryInactive: COLOR_DARK_ICON_NAVIGATION_PRIMARY_INACTIVE,
    iconNavigationSecondaryEnd: COLOR_DARK_ICON_NAVIGATION_SECONDARY_END,
    iconNavigationSecondaryStart: COLOR_DARK_ICON_NAVIGATION_SECONDARY_START,
    iconPrimary: COLOR_DARK_ICON_PRIMARY,
    iconPrimaryInverse: COLOR_DARK_ICON_PRIMARY_INVERSE,
    iconPrimaryOverlay: COLOR_DARK_ICON_PRIMARY_OVERLAY,
    iconPrimaryOverlayInverse: COLOR_DARK_ICON_PRIMARY_OVERLAY_INVERSE,
    iconRadioSelectedDisabled: COLOR_DARK_ICON_RADIO_SELECTED_DISABLED,
    iconRadioSelectedEnabled: COLOR_DARK_ICON_RADIO_SELECTED_ENABLED,
    iconRecCardContentHidden: COLOR_DARK_ICON_REC_CARD_CONTENT_HIDDEN,
    iconSearchEndAction: COLOR_DARK_ICON_SEARCH_END_ACTION,
    iconSearchStart: COLOR_DARK_ICON_SEARCH_START,
    iconSecondary: COLOR_DARK_ICON_SECONDARY,
    iconSecondaryInverse: COLOR_DARK_ICON_SECONDARY_INVERSE,
    iconSelectorSelectedDisabled: COLOR_DARK_ICON_SELECTOR_SELECTED_DISABLED,
    iconSelectorSelectedEnabled: COLOR_DARK_ICON_SELECTOR_SELECTED_ENABLED,
    iconSuccess: COLOR_DARK_ICON_SUCCESS,
    iconSwitchAltDisabled: COLOR_DARK_ICON_SWITCH_ALT_DISABLED,
    iconSwitchAltSelected: COLOR_DARK_ICON_SWITCH_ALT_SELECTED,
    iconSwitchAltUnselected: COLOR_DARK_ICON_SWITCH_ALT_UNSELECTED,
    iconSwitchDefaultDisabled: COLOR_DARK_ICON_SWITCH_DEFAULT_DISABLED,
    iconSwitchDefaultSelected: COLOR_DARK_ICON_SWITCH_DEFAULT_SELECTED,
    iconSwitchDefaultUnselected: COLOR_DARK_ICON_SWITCH_DEFAULT_UNSELECTED,
    iconTooltipDismiss: COLOR_DARK_ICON_TOOLTIP_DISMISS,
    iconTrust: COLOR_DARK_ICON_TRUST,
    iconVault: COLOR_DARK_ICON_VAULT,
    interactiveButtonNeutral: COLOR_DARK_INTERACTIVE_BUTTON_NEUTRAL,
    interactiveButtonPrimary: COLOR_DARK_INTERACTIVE_BUTTON_PRIMARY,
    interactiveButtonSecondary: COLOR_DARK_INTERACTIVE_BUTTON_SECONDARY,
    interactiveButtonTertiary: COLOR_DARK_INTERACTIVE_BUTTON_TERTIARY,
    interactiveIconButtonOverlay: COLOR_DARK_INTERACTIVE_ICON_BUTTON_OVERLAY,
    interactiveIconButtonPrimary: COLOR_DARK_INTERACTIVE_ICON_BUTTON_PRIMARY,
    interactiveIconButtonSecondary: COLOR_DARK_INTERACTIVE_ICON_BUTTON_SECONDARY,
    interactiveOnLight: COLOR_DARK_INTERACTIVE_ON_LIGHT,
    interactivePrimary: COLOR_DARK_INTERACTIVE_PRIMARY,
    interactiveSecondary: COLOR_DARK_INTERACTIVE_SECONDARY,
    invertibleBlack: COLOR_WHITE,
    invertibleBlue05: COLOR_BLUE_95,
    invertibleBlue10: COLOR_BLUE_95,
    invertibleBlue15: COLOR_BLUE_90,
    invertibleBlue20: COLOR_BLUE_80,
    invertibleBlue30: COLOR_BLUE_80,
    invertibleBlue40: COLOR_BLUE_70,
    invertibleBlue50: COLOR_BLUE_60,
    invertibleBlue60: COLOR_BLUE_50,
    invertibleBlue70: COLOR_BLUE_40,
    invertibleBlue80: COLOR_BLUE_20,
    invertibleBlue90: COLOR_BLUE_15,
    invertibleBlue95: COLOR_BLUE_10,
    invertibleFuchsia05: COLOR_FUCHSIA_95,
    invertibleFuchsia10: COLOR_FUCHSIA_95,
    invertibleFuchsia15: COLOR_FUCHSIA_90,
    invertibleFuchsia20: COLOR_FUCHSIA_80,
    invertibleFuchsia30: COLOR_FUCHSIA_80,
    invertibleFuchsia40: COLOR_FUCHSIA_70,
    invertibleFuchsia50: COLOR_FUCHSIA_60,
    invertibleFuchsia60: COLOR_FUCHSIA_50,
    invertibleFuchsia70: COLOR_FUCHSIA_40,
    invertibleFuchsia80: COLOR_FUCHSIA_20,
    invertibleFuchsia90: COLOR_FUCHSIA_15,
    invertibleFuchsia95: COLOR_FUCHSIA_10,
    invertibleGold05: COLOR_GOLD_95,
    invertibleGold10: COLOR_GOLD_95,
    invertibleGold15: COLOR_GOLD_90,
    invertibleGold20: COLOR_GOLD_80,
    invertibleGold30: COLOR_GOLD_80,
    invertibleGold40: COLOR_GOLD_70,
    invertibleGold50: COLOR_GOLD_60,
    invertibleGold60: COLOR_GOLD_50,
    invertibleGold70: COLOR_GOLD_40,
    invertibleGold80: COLOR_GOLD_20,
    invertibleGold90: COLOR_GOLD_15,
    invertibleGold95: COLOR_GOLD_10,
    invertibleGray05: COLOR_GRAY_95,
    invertibleGray10: COLOR_GRAY_95,
    invertibleGray15: COLOR_GRAY_90,
    invertibleGray20: COLOR_GRAY_80,
    invertibleGray30: COLOR_GRAY_80,
    invertibleGray40: COLOR_GRAY_70,
    invertibleGray50: COLOR_GRAY_60,
    invertibleGray60: COLOR_GRAY_50,
    invertibleGray70: COLOR_GRAY_40,
    invertibleGray80: COLOR_GRAY_20,
    invertibleGray90: COLOR_GRAY_15,
    invertibleGray95: COLOR_GRAY_10,
    invertibleGreen05: COLOR_GREEN_95,
    invertibleGreen10: COLOR_GREEN_95,
    invertibleGreen15: COLOR_GREEN_90,
    invertibleGreen20: COLOR_GREEN_80,
    invertibleGreen30: COLOR_GREEN_80,
    invertibleGreen40: COLOR_GREEN_70,
    invertibleGreen50: COLOR_GREEN_60,
    invertibleGreen60: COLOR_GREEN_50,
    invertibleGreen70: COLOR_GREEN_40,
    invertibleGreen80: COLOR_GREEN_20,
    invertibleGreen90: COLOR_GREEN_15,
    invertibleGreen95: COLOR_GREEN_10,
    invertiblePurple05: COLOR_PURPLE_95,
    invertiblePurple10: COLOR_PURPLE_95,
    invertiblePurple15: COLOR_PURPLE_90,
    invertiblePurple20: COLOR_PURPLE_80,
    invertiblePurple30: COLOR_PURPLE_80,
    invertiblePurple40: COLOR_PURPLE_70,
    invertiblePurple50: COLOR_PURPLE_60,
    invertiblePurple60: COLOR_PURPLE_50,
    invertiblePurple70: COLOR_PURPLE_40,
    invertiblePurple80: COLOR_PURPLE_20,
    invertiblePurple90: COLOR_PURPLE_15,
    invertiblePurple95: COLOR_PURPLE_10,
    invertibleRed05: COLOR_RED_95,
    invertibleRed10: COLOR_RED_95,
    invertibleRed15: COLOR_RED_90,
    invertibleRed20: COLOR_RED_80,
    invertibleRed30: COLOR_RED_80,
    invertibleRed40: COLOR_RED_70,
    invertibleRed50: COLOR_RED_60,
    invertibleRed60: COLOR_RED_50,
    invertibleRed70: COLOR_RED_40,
    invertibleRed80: COLOR_RED_20,
    invertibleRed90: COLOR_RED_15,
    invertibleRed95: COLOR_RED_10,
    invertibleTeal05: COLOR_TEAL_95,
    invertibleTeal10: COLOR_TEAL_95,
    invertibleTeal15: COLOR_TEAL_90,
    invertibleTeal20: COLOR_TEAL_80,
    invertibleTeal30: COLOR_TEAL_80,
    invertibleTeal40: COLOR_TEAL_70,
    invertibleTeal50: COLOR_TEAL_60,
    invertibleTeal60: COLOR_TEAL_50,
    invertibleTeal70: COLOR_TEAL_40,
    invertibleTeal80: COLOR_TEAL_20,
    invertibleTeal90: COLOR_TEAL_15,
    invertibleTeal95: COLOR_TEAL_10,
    invertibleWhite: COLOR_BLACK,
    invertibleYellowOrange05: COLOR_YELLOW_ORANGE_95,
    invertibleYellowOrange10: COLOR_YELLOW_ORANGE_95,
    invertibleYellowOrange15: COLOR_YELLOW_ORANGE_90,
    invertibleYellowOrange20: COLOR_YELLOW_ORANGE_80,
    invertibleYellowOrange30: COLOR_YELLOW_ORANGE_80,
    invertibleYellowOrange40: COLOR_YELLOW_ORANGE_70,
    invertibleYellowOrange50: COLOR_YELLOW_ORANGE_60,
    invertibleYellowOrange60: COLOR_YELLOW_ORANGE_50,
    invertibleYellowOrange70: COLOR_YELLOW_ORANGE_40,
    invertibleYellowOrange80: COLOR_YELLOW_ORANGE_20,
    invertibleYellowOrange90: COLOR_YELLOW_ORANGE_15,
    invertibleYellowOrange95: COLOR_YELLOW_ORANGE_10,
    labelGamepadPrimaryCountBoost: COLOR_DARK_LABEL_GAMEPAD_PRIMARY_COUNT_BOOST,
    labelGamepadPrimaryCountSuperLike: COLOR_DARK_LABEL_GAMEPAD_PRIMARY_COUNT_SUPER_LIKE,
    labelGamepadSecondaryCountBoost: COLOR_DARK_LABEL_GAMEPAD_SECONDARY_COUNT_BOOST,
    labelGamepadSecondaryCountSuperLike: COLOR_DARK_LABEL_GAMEPAD_SECONDARY_COUNT_SUPER_LIKE,
    labelIconButtonDisabled: COLOR_DARK_LABEL_ICON_BUTTON_DISABLED,
    labelIconButtonOverlayDefault: COLOR_DARK_LABEL_ICON_BUTTON_OVERLAY_DEFAULT,
    labelIconButtonOverlayDisabled: COLOR_DARK_LABEL_ICON_BUTTON_OVERLAY_DISABLED,
    labelIconButtonPrimary: COLOR_DARK_LABEL_ICON_BUTTON_PRIMARY,
    labelIconButtonSecondary: COLOR_DARK_LABEL_ICON_BUTTON_SECONDARY,
    loaderShimmerBaseDefault: COLOR_DARK_LOADER_SHIMMER_BASE_DEFAULT,
    loaderShimmerHighlightDefault: COLOR_DARK_LOADER_SHIMMER_HIGHLIGHT_DEFAULT,
    loaderSkeleton: COLOR_DARK_LOADER_SKELETON,
    overlayDefault: COLOR_DARK_OVERLAY_DEFAULT,
    shadowContainerElevated: COLOR_DARK_SHADOW_CONTAINER_ELEVATED,
    subCardRecCardSparks: COLOR_DARK_SUB_CARD_REC_CARD_SPARKS,
    textBadgeNotificationDefault: COLOR_DARK_TEXT_BADGE_NOTIFICATION_DEFAULT,
    textBadgeNotificationInactive: COLOR_DARK_TEXT_BADGE_NOTIFICATION_INACTIVE,
    textBannerBody: COLOR_DARK_TEXT_BANNER_BODY,
    textBannerHeading: COLOR_DARK_TEXT_BANNER_HEADING,
    textBoost: COLOR_DARK_TEXT_BOOST,
    textBrandLarge: COLOR_DARK_TEXT_BRAND_LARGE,
    textBrandNormal: COLOR_DARK_TEXT_BRAND_NORMAL,
    textChatBubbleReceive: COLOR_DARK_TEXT_CHAT_BUBBLE_RECEIVE,
    textChatBubbleSend: COLOR_DARK_TEXT_CHAT_BUBBLE_SEND,
    textDatepickerActive: COLOR_DARK_TEXT_DATEPICKER_ACTIVE,
    textDatepickerInactive: COLOR_DARK_TEXT_DATEPICKER_INACTIVE,
    textDisabled: COLOR_DARK_TEXT_DISABLED,
    textError: COLOR_DARK_TEXT_ERROR,
    textFormHelpDefault: COLOR_DARK_TEXT_FORM_HELP_DEFAULT,
    textFormHelpDisabled: COLOR_DARK_TEXT_FORM_HELP_DISABLED,
    textFormHelpError: COLOR_DARK_TEXT_FORM_HELP_ERROR,
    textFormHelpSuccess: COLOR_DARK_TEXT_FORM_HELP_SUCCESS,
    textFormLabelDefault: COLOR_DARK_TEXT_FORM_LABEL_DEFAULT,
    textGold: COLOR_DARK_TEXT_GOLD,
    textHighlightBackground: COLOR_DARK_TEXT_HIGHLIGHT_BACKGROUND,
    textHighlightForeground: COLOR_DARK_TEXT_HIGHLIGHT_FOREGROUND,
    textInactive: COLOR_DARK_TEXT_INACTIVE,
    textLike: COLOR_DARK_TEXT_LIKE,
    textLink: COLOR_DARK_TEXT_LINK,
    textLinkOverlay: COLOR_DARK_TEXT_LINK_OVERLAY,
    textPassionsActive: COLOR_DARK_TEXT_PASSIONS_ACTIVE,
    textPassionsInactive: COLOR_DARK_TEXT_PASSIONS_INACTIVE,
    textPassionsInactiveOverlay: COLOR_DARK_TEXT_PASSIONS_INACTIVE_OVERLAY,
    textPassionsShared: COLOR_DARK_TEXT_PASSIONS_SHARED,
    textPassionsSharedOverlay: COLOR_DARK_TEXT_PASSIONS_SHARED_OVERLAY,
    textPassionsSharedRec: COLOR_DARK_TEXT_PASSIONS_SHARED_REC,
    textPrimary: COLOR_DARK_TEXT_PRIMARY,
    textPrimaryInverse: COLOR_DARK_TEXT_PRIMARY_INVERSE,
    textPrimaryOverlay: COLOR_DARK_TEXT_PRIMARY_OVERLAY,
    textPrimaryOverlayInverse: COLOR_DARK_TEXT_PRIMARY_OVERLAY_INVERSE,
    textRecCardContentHidden: COLOR_DARK_TEXT_REC_CARD_CONTENT_HIDDEN,
    textSearchInputActive: COLOR_DARK_TEXT_SEARCH_INPUT_ACTIVE,
    textSearchInputInactive: COLOR_DARK_TEXT_SEARCH_INPUT_INACTIVE,
    textSearchPlaceholderInactive: COLOR_DARK_TEXT_SEARCH_PLACEHOLDER_INACTIVE,
    textSecondary: COLOR_DARK_TEXT_SECONDARY,
    textSecondaryInverse: COLOR_DARK_TEXT_SECONDARY_INVERSE,
    textSecondaryOverlay: COLOR_DARK_TEXT_SECONDARY_OVERLAY,
    textSecondaryOverlayInverse: COLOR_DARK_TEXT_SECONDARY_OVERLAY_INVERSE,
    textSuccess: COLOR_DARK_TEXT_SUCCESS,
    textSuperBoost: COLOR_DARK_TEXT_SUPER_BOOST,
    textSuperLike: COLOR_DARK_TEXT_SUPER_LIKE,
    textTextFieldLoudCharactercountDefault: COLOR_DARK_TEXT_TEXT_FIELD_LOUD_CHARACTERCOUNT_DEFAULT,
    textTextFieldLoudInputDefault: COLOR_DARK_TEXT_TEXT_FIELD_LOUD_INPUT_DEFAULT,
    textTextFieldLoudInputDisabled: COLOR_DARK_TEXT_TEXT_FIELD_LOUD_INPUT_DISABLED,
    textTextFieldLoudLabelError: COLOR_DARK_TEXT_TEXT_FIELD_LOUD_LABEL_ERROR,
    textTextFieldLoudLabelOptional: COLOR_DARK_TEXT_TEXT_FIELD_LOUD_LABEL_OPTIONAL,
    textTextFieldLoudPlaceholderDefault: COLOR_DARK_TEXT_TEXT_FIELD_LOUD_PLACEHOLDER_DEFAULT,
    textTextFieldQuietCharactercountDefault:
      COLOR_DARK_TEXT_TEXT_FIELD_QUIET_CHARACTERCOUNT_DEFAULT,
    textTextFieldQuietInputDefault: COLOR_DARK_TEXT_TEXT_FIELD_QUIET_INPUT_DEFAULT,
    textTextFieldQuietInputDisabled: COLOR_DARK_TEXT_TEXT_FIELD_QUIET_INPUT_DISABLED,
    textTextFieldQuietLabelError: COLOR_DARK_TEXT_TEXT_FIELD_QUIET_LABEL_ERROR,
    textTextFieldQuietLabelOptional: COLOR_DARK_TEXT_TEXT_FIELD_QUIET_LABEL_OPTIONAL,
    textTextFieldQuietPlaceholderDefault: COLOR_DARK_TEXT_TEXT_FIELD_QUIET_PLACEHOLDER_DEFAULT,
    textTooltipDefault: COLOR_DARK_TEXT_TOOLTIP_DEFAULT,
    textTooltipRevenueDefault: COLOR_DARK_TEXT_TOOLTIP_REVENUE_DEFAULT,
    textTooltipTrustDefault: COLOR_DARK_TEXT_TOOLTIP_TRUST_DEFAULT,
    textTrust: COLOR_DARK_TEXT_TRUST,
    textVaultLarge: COLOR_DARK_TEXT_VAULT_LARGE,
    textVaultNormal: COLOR_DARK_TEXT_VAULT_NORMAL,
  },
  fontSize: {
    ...THEME_DEFAULT.fontSize,
    base: FONT_SIZE_BASE,
  },
  gradient: {
    ...THEME_DEFAULT.gradient,
    accentBoostGradient: GRADIENT_DARK_ACCENT_BOOST_GRADIENT,
    accentBrandGradient: GRADIENT_DARK_ACCENT_BRAND_GRADIENT,
    accentExploreGradient: GRADIENT_DARK_ACCENT_EXPLORE_GRADIENT,
    accentFestivalModeGradient: GRADIENT_DARK_ACCENT_FESTIVAL_MODE_GRADIENT,
    accentGoldGradient: GRADIENT_DARK_ACCENT_GOLD_GRADIENT,
    accentGoldShineGradient: GRADIENT_DARK_ACCENT_GOLD_SHINE_GRADIENT,
    accentHotTakesGradient: GRADIENT_DARK_ACCENT_HOT_TAKES_GRADIENT,
    accentLikeGradient: GRADIENT_DARK_ACCENT_LIKE_GRADIENT,
    accentMatchExpirationGradient: GRADIENT_DARK_ACCENT_MATCH_EXPIRATION_GRADIENT,
    accentMatchmakerGradient: GRADIENT_DARK_ACCENT_MATCHMAKER_GRADIENT,
    accentNopeGradient: GRADIENT_DARK_ACCENT_NOPE_GRADIENT,
    accentPassionsGradient: GRADIENT_DARK_ACCENT_PASSIONS_GRADIENT,
    accentPlatinumGradient: GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT,
    accentPlatinumGradientInverse: GRADIENT_DARK_ACCENT_PLATINUM_GRADIENT_INVERSE,
    accentPlatinumShineGradient: GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT,
    accentPlatinumShineGradientInverse: GRADIENT_DARK_ACCENT_PLATINUM_SHINE_GRADIENT_INVERSE,
    accentPrimaryGradient: GRADIENT_DARK_ACCENT_PRIMARY_GRADIENT,
    accentRewindGradient: GRADIENT_DARK_ACCENT_REWIND_GRADIENT,
    accentSelectGradient: GRADIENT_DARK_ACCENT_SELECT_GRADIENT,
    accentSparksBoostGradient: GRADIENT_DARK_ACCENT_SPARKS_BOOST_GRADIENT,
    accentSparksLikeGradient: GRADIENT_DARK_ACCENT_SPARKS_LIKE_GRADIENT,
    accentSparksNopeGradient: GRADIENT_DARK_ACCENT_SPARKS_NOPE_GRADIENT,
    accentSparksRewindGradient: GRADIENT_DARK_ACCENT_SPARKS_REWIND_GRADIENT,
    accentSparksSuperLikeGradient: GRADIENT_DARK_ACCENT_SPARKS_SUPER_LIKE_GRADIENT,
    accentSpotifyMusicModeGradient: GRADIENT_DARK_ACCENT_SPOTIFY_MUSIC_MODE_GRADIENT,
    accentSuperBoostGradient: GRADIENT_DARK_ACCENT_SUPER_BOOST_GRADIENT,
    accentSuperLikeGradient: GRADIENT_DARK_ACCENT_SUPER_LIKE_GRADIENT,
    accentVibesGradient: GRADIENT_DARK_ACCENT_VIBES_GRADIENT,
    backgroundBoost: GRADIENT_DARK_BACKGROUND_BOOST,
    backgroundBoostInverse: GRADIENT_DARK_BACKGROUND_BOOST_INVERSE,
    backgroundBoostSubtle: GRADIENT_DARK_BACKGROUND_BOOST_SUBTLE,
    backgroundBrandGradient: GRADIENT_DARK_BACKGROUND_BRAND_GRADIENT,
    backgroundBrandSubtle: GRADIENT_DARK_BACKGROUND_BRAND_SUBTLE,
    backgroundButtonPrimary: GRADIENT_DARK_BACKGROUND_BUTTON_PRIMARY,
    backgroundCardSparksHighlightCommon1: GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_1,
    backgroundCardSparksHighlightCommon2: GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_2,
    backgroundCardSparksHighlightCommon3: GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_COMMON_3,
    backgroundCardSparksHighlightUncommon1:
      GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_1,
    backgroundCardSparksHighlightUncommon2:
      GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_2,
    backgroundCardSparksHighlightUncommon3:
      GRADIENT_DARK_BACKGROUND_CARD_SPARKS_HIGHLIGHT_UNCOMMON_3,
    backgroundCardSparksIcebreaker: GRADIENT_DARK_BACKGROUND_CARD_SPARKS_ICEBREAKER,
    backgroundCardSparksPrompt: GRADIENT_DARK_BACKGROUND_CARD_SPARKS_PROMPT,
    backgroundCardSparksQuiz: GRADIENT_DARK_BACKGROUND_CARD_SPARKS_QUIZ,
    backgroundExploreAttribution: GRADIENT_DARK_BACKGROUND_EXPLORE_ATTRIBUTION,
    backgroundFestivalMode: GRADIENT_DARK_BACKGROUND_FESTIVAL_MODE,
    backgroundGamepadBoostPressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_BOOST_PRESSED,
    backgroundGamepadLikePressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_LIKE_PRESSED,
    backgroundGamepadNopePressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_NOPE_PRESSED,
    backgroundGamepadRewindPressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_REWIND_PRESSED,
    backgroundGamepadSparksBoostPressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_BOOST_PRESSED,
    backgroundGamepadSparksLikePressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_LIKE_PRESSED,
    backgroundGamepadSparksNopePressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_NOPE_PRESSED,
    backgroundGamepadSparksRewindPressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_REWIND_PRESSED,
    backgroundGamepadSparksSuperLikePressed:
      GRADIENT_DARK_BACKGROUND_GAMEPAD_SPARKS_SUPER_LIKE_PRESSED,
    backgroundGamepadSuperLikePressed: GRADIENT_DARK_BACKGROUND_GAMEPAD_SUPER_LIKE_PRESSED,
    backgroundGold: GRADIENT_DARK_BACKGROUND_GOLD,
    backgroundGoldInverse: GRADIENT_DARK_BACKGROUND_GOLD_INVERSE,
    backgroundGoldShine: GRADIENT_DARK_BACKGROUND_GOLD_SHINE,
    backgroundGoldShineInverse: GRADIENT_DARK_BACKGROUND_GOLD_SHINE_INVERSE,
    backgroundGoldSubtle: GRADIENT_DARK_BACKGROUND_GOLD_SUBTLE,
    backgroundHotTakes: GRADIENT_DARK_BACKGROUND_HOT_TAKES,
    backgroundIconButtonPrimary: GRADIENT_DARK_BACKGROUND_ICON_BUTTON_PRIMARY,
    backgroundLike: GRADIENT_DARK_BACKGROUND_LIKE,
    backgroundLikeInverse: GRADIENT_DARK_BACKGROUND_LIKE_INVERSE,
    backgroundLikeSubtle: GRADIENT_DARK_BACKGROUND_LIKE_SUBTLE,
    backgroundMatchExpiration: GRADIENT_DARK_BACKGROUND_MATCH_EXPIRATION,
    backgroundNope: GRADIENT_DARK_BACKGROUND_NOPE,
    backgroundNopeInverse: GRADIENT_DARK_BACKGROUND_NOPE_INVERSE,
    backgroundPassionsSharedRec: GRADIENT_DARK_BACKGROUND_PASSIONS_SHARED_REC,
    backgroundPassionsSparksSharedOverlay: GRADIENT_DARK_BACKGROUND_PASSIONS_SPARKS_SHARED_OVERLAY,
    backgroundPlatinum: GRADIENT_DARK_BACKGROUND_PLATINUM,
    backgroundPlatinumInverse: GRADIENT_DARK_BACKGROUND_PLATINUM_INVERSE,
    backgroundPlatinumShine: GRADIENT_DARK_BACKGROUND_PLATINUM_SHINE,
    backgroundPlatinumShineInverse: GRADIENT_DARK_BACKGROUND_PLATINUM_SHINE_INVERSE,
    backgroundPlatinumSubtle: GRADIENT_DARK_BACKGROUND_PLATINUM_SUBTLE,
    backgroundPlusSubtle: GRADIENT_DARK_BACKGROUND_PLUS_SUBTLE,
    backgroundPrimaryLinear: GRADIENT_DARK_BACKGROUND_PRIMARY_LINEAR,
    backgroundRecCardBottomAiGradient: GRADIENT_DARK_BACKGROUND_REC_CARD_BOTTOM_AI_GRADIENT,
    backgroundRewind: GRADIENT_DARK_BACKGROUND_REWIND,
    backgroundRewindInverse: GRADIENT_DARK_BACKGROUND_REWIND_INVERSE,
    backgroundScriptedOnboarding: GRADIENT_DARK_BACKGROUND_SCRIPTED_ONBOARDING,
    backgroundSelectSubtle: GRADIENT_DARK_BACKGROUND_SELECT_SUBTLE,
    backgroundSparksBoost: GRADIENT_DARK_BACKGROUND_SPARKS_BOOST,
    backgroundSparksLike: GRADIENT_DARK_BACKGROUND_SPARKS_LIKE,
    backgroundSparksNope: GRADIENT_DARK_BACKGROUND_SPARKS_NOPE,
    backgroundSparksPrimary: GRADIENT_DARK_BACKGROUND_SPARKS_PRIMARY,
    backgroundSparksRewind: GRADIENT_DARK_BACKGROUND_SPARKS_REWIND,
    backgroundSparksSuperLike: GRADIENT_DARK_BACKGROUND_SPARKS_SUPER_LIKE,
    backgroundSpotifyMusicMode: GRADIENT_DARK_BACKGROUND_SPOTIFY_MUSIC_MODE,
    backgroundSuperBoost: GRADIENT_DARK_BACKGROUND_SUPER_BOOST,
    backgroundSuperBoostInverse: GRADIENT_DARK_BACKGROUND_SUPER_BOOST_INVERSE,
    backgroundSuperBoostSubtle: GRADIENT_DARK_BACKGROUND_SUPER_BOOST_SUBTLE,
    backgroundSuperLike: GRADIENT_DARK_BACKGROUND_SUPER_LIKE,
    backgroundSuperLikeInverse: GRADIENT_DARK_BACKGROUND_SUPER_LIKE_INVERSE,
    backgroundSuperLikeSubtle: GRADIENT_DARK_BACKGROUND_SUPER_LIKE_SUBTLE,
    backgroundSwipesurge: GRADIENT_DARK_BACKGROUND_SWIPESURGE,
    backgroundTealSubtle: GRADIENT_DARK_BACKGROUND_TEAL_SUBTLE,
    backgroundVaultGradient: GRADIENT_DARK_BACKGROUND_VAULT_GRADIENT,
    backgroundVaultSubtle: GRADIENT_DARK_BACKGROUND_VAULT_SUBTLE,
    borderBrandGradient: GRADIENT_DARK_BORDER_BRAND_GRADIENT,
    borderMatchExpiration: GRADIENT_DARK_BORDER_MATCH_EXPIRATION,
    borderSparksPromptSelected: GRADIENT_DARK_BORDER_SPARKS_PROMPT_SELECTED,
    borderVaultGradient: GRADIENT_DARK_BORDER_VAULT_GRADIENT,
    fadePrimaryBottomToTop: GRADIENT_DARK_FADE_PRIMARY_BOTTOM_TO_TOP,
    fadePrimaryTopToBottom: GRADIENT_DARK_FADE_PRIMARY_TOP_TO_BOTTOM,
    foregroundProgressActive: GRADIENT_DARK_FOREGROUND_PROGRESS_ACTIVE,
    iconBoost: GRADIENT_DARK_ICON_BOOST,
    iconBrandGradient: GRADIENT_DARK_ICON_BRAND_GRADIENT,
    iconChatDrawerVibesActive: GRADIENT_DARK_ICON_CHAT_DRAWER_VIBES_ACTIVE,
    iconContainerBannerDefault: GRADIENT_DARK_ICON_CONTAINER_BANNER_DEFAULT,
    iconGamepadPrimaryBoostDefault: GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_BOOST_DEFAULT,
    iconGamepadPrimaryLikeDefault: GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_LIKE_DEFAULT,
    iconGamepadPrimaryNopeDefault: GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_NOPE_DEFAULT,
    iconGamepadPrimaryRewindDefault: GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_REWIND_DEFAULT,
    iconGamepadPrimarySuperLikeDefault: GRADIENT_DARK_ICON_GAMEPAD_PRIMARY_SUPER_LIKE_DEFAULT,
    iconGamepadSecondaryBoostDefault: GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_BOOST_DEFAULT,
    iconGamepadSecondaryLikeDefault: GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_LIKE_DEFAULT,
    iconGamepadSecondaryNopeDefault: GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_NOPE_DEFAULT,
    iconGamepadSecondaryRewindDefault: GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_REWIND_DEFAULT,
    iconGamepadSecondarySuperLikeDefault: GRADIENT_DARK_ICON_GAMEPAD_SECONDARY_SUPER_LIKE_DEFAULT,
    iconGamepadSparksBoostDefault: GRADIENT_DARK_ICON_GAMEPAD_SPARKS_BOOST_DEFAULT,
    iconGamepadSparksLikeDefault: GRADIENT_DARK_ICON_GAMEPAD_SPARKS_LIKE_DEFAULT,
    iconGamepadSparksNopeDefault: GRADIENT_DARK_ICON_GAMEPAD_SPARKS_NOPE_DEFAULT,
    iconGamepadSparksRewindDefault: GRADIENT_DARK_ICON_GAMEPAD_SPARKS_REWIND_DEFAULT,
    iconGamepadSparksSuperLikeDefault: GRADIENT_DARK_ICON_GAMEPAD_SPARKS_SUPER_LIKE_DEFAULT,
    iconGold: GRADIENT_DARK_ICON_GOLD,
    iconLike: GRADIENT_DARK_ICON_LIKE,
    iconMatchExpiration: GRADIENT_DARK_ICON_MATCH_EXPIRATION,
    iconNavigationPrimaryActive: GRADIENT_DARK_ICON_NAVIGATION_PRIMARY_ACTIVE,
    iconNope: GRADIENT_DARK_ICON_NOPE,
    iconPlatinum: GRADIENT_DARK_ICON_PLATINUM,
    iconRewind: GRADIENT_DARK_ICON_REWIND,
    iconSparksBoost: GRADIENT_DARK_ICON_SPARKS_BOOST,
    iconSparksLike: GRADIENT_DARK_ICON_SPARKS_LIKE,
    iconSparksMatchmakerAttribution: GRADIENT_DARK_ICON_SPARKS_MATCHMAKER_ATTRIBUTION,
    iconSparksNope: GRADIENT_DARK_ICON_SPARKS_NOPE,
    iconSparksRewind: GRADIENT_DARK_ICON_SPARKS_REWIND,
    iconSparksSuperLike: GRADIENT_DARK_ICON_SPARKS_SUPER_LIKE,
    iconSuperlike: GRADIENT_DARK_ICON_SUPERLIKE,
    iconVaultGradient: GRADIENT_DARK_ICON_VAULT_GRADIENT,
    overlayCard: GRADIENT_DARK_OVERLAY_CARD,
    overlayPrimaryGradient: GRADIENT_DARK_OVERLAY_PRIMARY_GRADIENT,
    overlayProfileButtonGamepad: GRADIENT_DARK_OVERLAY_PROFILE_BUTTON_GAMEPAD,
    overlayProfileSparksSuperLike: GRADIENT_DARK_OVERLAY_PROFILE_SPARKS_SUPER_LIKE,
    overlayRecCardDefault: GRADIENT_DARK_OVERLAY_REC_CARD_DEFAULT,
    overlayRecCardHighlight: GRADIENT_DARK_OVERLAY_REC_CARD_HIGHLIGHT,
    overlayRecCardIntentA: GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_A,
    overlayRecCardIntentB: GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_B,
    overlayRecCardIntentC: GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_C,
    overlayRecCardIntentD: GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_D,
    overlayRecCardIntentE: GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_E,
    overlayRecCardIntentF: GRADIENT_DARK_OVERLAY_REC_CARD_INTENT_F,
    overlayRecCardSparksSuperLike: GRADIENT_DARK_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE,
    overlayRecCardSuperLike: GRADIENT_DARK_OVERLAY_REC_CARD_SUPER_LIKE,
    overlayRecCardVault: GRADIENT_DARK_OVERLAY_REC_CARD_VAULT,
    overlaySecondaryGradient: GRADIENT_DARK_OVERLAY_SECONDARY_GRADIENT,
    overlaySubtleCard: GRADIENT_DARK_OVERLAY_SUBTLE_CARD,
    shimmerGold: GRADIENT_DARK_SHIMMER_GOLD,
    shimmerPlatinum: GRADIENT_DARK_SHIMMER_PLATINUM,
    swipeOverlayRecCardSparksLike: GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_LIKE,
    swipeOverlayRecCardSparksNope: GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_NOPE,
    swipeOverlayRecCardSparksSuperLike: GRADIENT_DARK_SWIPE_OVERLAY_REC_CARD_SPARKS_SUPER_LIKE,
    textMatchExpiration: GRADIENT_DARK_TEXT_MATCH_EXPIRATION,
    textSparksMatchmakerAttribution: GRADIENT_DARK_TEXT_SPARKS_MATCHMAKER_ATTRIBUTION,
  },
} as ObsidianTheme;
